webpackJsonp([1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	__webpack_require__(268);
	
	var createHashHistory = __webpack_require__(62);
	var React = __webpack_require__(2);
	
	var _require = __webpack_require__(181);
	
	var render = _require.render;
	
	var _require2 = __webpack_require__(195);
	
	var Router = _require2.Router;
	var useRouterHistory = _require2.useRouterHistory;
	
	var useScroll = __webpack_require__(265);
	
	var routes = __webpack_require__(153);
	
	var history = useRouterHistory(useScroll(createHashHistory))();
	
	render({
	  $$typeof: _typeofReactElement,
	  type: Router,
	  key: null,
	  ref: null,
	  props: _defaultProps(Router.defaultProps, {
	    history: history,
	    routes: routes
	  }),
	  _owner: null
	}, document.getElementById('app'));

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var extend = __webpack_require__(33);
	var storage = __webpack_require__(93);
	
	var STORAGE_KEY = 'settings';
	
	var SettingsStore = {
	  autoCollapse: true,
	  replyLinks: true,
	  showDead: false,
	  showDeleted: false,
	  darkThemeMode: 'auto',
	  titleFontSize: 18,
	  listSpacing: 16,
	
	  load: function load() {
	    var json = storage.get(STORAGE_KEY);
	    if (json) {
	      extend(this, JSON.parse(json));
	    }
	  },
	
	  save: function save() {
	    storage.set(STORAGE_KEY, JSON.stringify({
	      autoCollapse: this.autoCollapse,
	      replyLinks: this.replyLinks,
	      showDead: this.showDead,
	      showDeleted: this.showDeleted,
	      darkThemeMode: this.darkThemeMode,
	      titleFontSize: this.titleFontSize,
	      listSpacing: this.listSpacing
	    }));
	  }
	};
	
	module.exports = SettingsStore;

/***/ },
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Firebase = __webpack_require__(175);
	
	var api = new Firebase('https://hacker-news.firebaseio.com/v0');
	
	function fetchItem(id, cb) {
	  itemRef(id).once('value', function (snapshot) {
	    cb(snapshot.val());
	  });
	}
	
	function fetchItems(ids, cb) {
	  var items = [];
	  ids.forEach(function (id) {
	    fetchItem(id, addItem);
	  });
	  function addItem(item) {
	    items.push(item);
	    if (items.length >= ids.length) {
	      cb(items);
	    }
	  }
	}
	
	function storiesRef(path) {
	  return api.child(path);
	}
	
	function itemRef(id) {
	  return api.child('item/' + id);
	}
	
	function userRef(id) {
	  return api.child('user/' + id);
	}
	
	function updatesRef() {
	  return api.child('updates/items');
	}
	
	module.exports = {
	  fetchItem: fetchItem,
	  fetchItems: fetchItems,
	  storiesRef: storiesRef,
	  itemRef: itemRef,
	  userRef: userRef,
	  updatesRef: updatesRef
	};

/***/ },
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	var React = __webpack_require__(2);
	
	// TODO Implement GIF-based fallback for IE9 and another non-animating browsers
	//      See https://github.com/tobiasahlin/SpinKit for how-to
	var Spinner = React.createClass({
	  displayName: 'Spinner',
	
	  getDefaultProps: function getDefaultProps() {
	    return { size: 6, spacing: 2 };
	  },
	
	  render: function render() {
	    var bounceSize = this.props.size + 'px';
	    var bounceStyle = { height: bounceSize, width: bounceSize, marginRight: this.props.spacing + 'px' };
	    return {
	      $$typeof: _typeofReactElement,
	      type: 'div',
	      key: null,
	      ref: null,
	      props: {
	        children: [{
	          $$typeof: _typeofReactElement,
	          type: 'div',
	          key: null,
	          ref: null,
	          props: {
	            className: 'bounce1',
	            style: bounceStyle
	          },
	          _owner: null
	        }, {
	          $$typeof: _typeofReactElement,
	          type: 'div',
	          key: null,
	          ref: null,
	          props: {
	            className: 'bounce2',
	            style: bounceStyle
	          },
	          _owner: null
	        }, {
	          $$typeof: _typeofReactElement,
	          type: 'div',
	          key: null,
	          ref: null,
	          props: {
	            className: 'bounce3',
	            style: bounceStyle
	          },
	          _owner: null
	        }],
	        className: 'Spinner',
	        style: { width: (Number(this.props.size) + Number(this.props.spacing)) * 3 + 'px' }
	      },
	      _owner: null
	    };
	  }
	});
	
	module.exports = Spinner;

/***/ },
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ function(module, exports) {

	/**
	 * Creates a className string including some class names conditionally.
	 * @param {string=} staticClassName class name(s) which should always be
	 *   included.
	 * @param {Object.<string, *>} conditionalClassNames an object mapping class
	 *   names to a value which indicates if the class name should be included -
	 *   class names will be included if their corresponding value is truthy.
	 * @return {string}
	 */
	'use strict';
	
	function buildClassName(staticClassName, conditionalClassNames) {
	  var classNames = [];
	  if (typeof conditionalClassNames == 'undefined') {
	    conditionalClassNames = staticClassName;
	  } else {
	    classNames.push(staticClassName);
	  }
	  var classNameKeys = Object.keys(conditionalClassNames);
	  for (var i = 0, l = classNameKeys.length; i < l; i++) {
	    if (conditionalClassNames[classNameKeys[i]]) {
	      classNames.push(classNameKeys[i]);
	    }
	  }
	  return classNames.join(' ');
	}
	
	module.exports = buildClassName;

/***/ },
/* 33 */
/***/ function(module, exports) {

	"use strict";
	
	function extend(dest, src1, src2) {
	  var props = Object.keys(src1);
	  for (var i = 0, l = props.length; i < l; i++) {
	    dest[props[i]] = src1[props[i]];
	  }
	  if (src2) {
	    props = Object.keys(src2);
	    for (i = 0, l = props.length; i < l; i++) {
	      dest[props[i]] = src2[props[i]];
	    }
	  }
	  return dest;
	}
	
	module.exports = extend;

/***/ },
/* 34 */
/***/ function(module, exports) {

	'use strict';
	
	function pluralise(howMany, suffixes) {
	  return (suffixes || ',s').split(',')[howMany === 1 ? 0 : 1];
	}
	
	module.exports = pluralise;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(41);
	
	var SITE_TITLE = _require.SITE_TITLE;
	
	function setTitle(title) {
	  document.title = title ? title + ' | ' + SITE_TITLE : SITE_TITLE;
	}
	
	module.exports = setTitle;

/***/ },
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(95);
	
	var EventEmitter = _require.EventEmitter;
	
	var HNService = __webpack_require__(14);
	
	var extend = __webpack_require__(33);
	
	/**
	 * Firebase reference used to stream updates - only one StoryStore instance can
	 * be active at a time.
	 */
	var firebaseRef = null;
	
	// Cache objects shared among StoryStore instances, also accessible via static
	// functions on the StoryStore constructor.
	
	/**
	 * Story ids by type, in rank order. Persisted to sessionStorage.
	 * @type Object.<type, Array.<id>>
	 */
	var idCache = {};
	
	/**
	 * Item cache. Persisted to sessionStorage.
	 * @type Object.<id, item>
	 */
	var itemCache = {};
	
	/**
	 * Story items in rank order for display, by type.
	 * @type Object.<type, Array.<item>>
	 */
	var storyLists = {};
	
	/**
	 * Populate the story list for the given story type from the cache.
	 */
	function populateStoryList(type) {
	  var ids = idCache[type];
	  var storyList = storyLists[type];
	  for (var i = 0, l = ids.length; i < l; i++) {
	    storyList[i] = itemCache[ids[i]] || null;
	  }
	}
	
	function parseJSON(json, defaultValue) {
	  return json ? JSON.parse(json) : defaultValue;
	}
	
	var StoryStore = (function (_EventEmitter) {
	  _inherits(StoryStore, _EventEmitter);
	
	  function StoryStore(type) {
	    _classCallCheck(this, StoryStore);
	
	    _EventEmitter.call(this);
	    this.type = type;
	
	    // Ensure cache objects for this type are initialised
	    if (!(type in idCache)) {
	      idCache[type] = [];
	    }
	    if (!(type in storyLists)) {
	      storyLists[type] = [];
	      populateStoryList(type);
	    }
	
	    // Pre-bind event handlers per instance
	    this.onStorage = this.onStorage.bind(this);
	    this.onStoriesUpdated = this.onStoriesUpdated.bind(this);
	  }
	
	  // Static, cache-related functions
	
	  StoryStore.prototype.getState = function getState() {
	    return {
	      ids: idCache[this.type],
	      stories: storyLists[this.type]
	    };
	  };
	
	  StoryStore.prototype.itemUpdated = function itemUpdated(item, index) {
	    storyLists[this.type][index] = item;
	    itemCache[item.id] = item;
	  };
	
	  /**
	   * Emit an item id event if a storage key corresponding to an item in the
	   * cache has changed.
	   */
	
	  StoryStore.prototype.onStorage = function onStorage(e) {
	    if (itemCache[e.key]) {
	      this.emit(e.key);
	    }
	  };
	
	  /**
	   * Handle story id snapshots from Firebase.
	   */
	
	  StoryStore.prototype.onStoriesUpdated = function onStoriesUpdated(snapshot) {
	    idCache[this.type] = snapshot.val();
	    populateStoryList(this.type);
	    this.emit('update', this.getState());
	  };
	
	  StoryStore.prototype.start = function start() {
	    firebaseRef = HNService.storiesRef(this.type);
	    firebaseRef.on('value', this.onStoriesUpdated);
	    window.addEventListener('storage', this.onStorage);
	  };
	
	  StoryStore.prototype.stop = function stop() {
	    if (firebaseRef !== null) {
	      firebaseRef.off();
	      firebaseRef = null;
	    }
	    window.removeEventListener('storage', this.onStorage);
	  };
	
	  return StoryStore;
	})(EventEmitter);
	
	extend(StoryStore, {
	  /**
	   * Get an item from the cache.
	   */
	  getItem: function getItem(id) {
	    return itemCache[id] || null;
	  },
	
	  /**
	   * Deserialise caches from sessionStorage.
	   */
	  loadSession: function loadSession() {
	    idCache = parseJSON(window.sessionStorage.idCache, {});
	    itemCache = parseJSON(window.sessionStorage.itemCache, {});
	  },
	
	  /**
	   * Serialise caches to sessionStorage as JSON.
	   */
	  saveSession: function saveSession() {
	    window.sessionStorage.idCache = JSON.stringify(idCache);
	    window.sessionStorage.itemCache = JSON.stringify(itemCache);
	  }
	});
	
	module.exports = StoryStore;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var EventEmitter = __webpack_require__(95).EventEmitter;
	
	var HNService = __webpack_require__(14);
	
	var _require = __webpack_require__(41);
	
	var UPDATES_CACHE_SIZE = _require.UPDATES_CACHE_SIZE;
	
	var extend = __webpack_require__(33);
	
	/**
	 * Firebase reference used to stream updates.
	 */
	var updatesRef = null;
	
	/**
	 * Contains item id -> item cache objects. Persisted to sessionStorage.
	 * @prop .comments {Object.<id,item>} comments cache.
	 * @prop .stories {Object.<id,item>} story cache.
	 */
	var updatesCache = null;
	
	/**
	 * Lists of items in reverse chronological order for display.
	 * @prop .comments {Array.<item>} comment updates.
	 * @prop .stories {Array.<item>} story updates.
	 */
	var updates = {};
	
	function sortByTimeDesc(a, b) {
	  return b.time - a.time;
	}
	
	function cacheObjToSortedArray(obj) {
	  var arr = Object.keys(obj).map(function (id) {
	    return obj[id];
	  });
	  arr.sort(sortByTimeDesc);
	  return arr;
	}
	
	/**
	 * Populate lists of updates for display from the cache.
	 */
	function populateUpdates() {
	  updates.comments = processCacheObj(updatesCache.comments);
	  updates.stories = processCacheObj(updatesCache.stories);
	}
	
	/**
	 * Create an array of items from a cache object, sorted in reverse chronological
	 * order. Evict the oldest items from the cache if it's grown above
	 * UPDATES_CACHE_SIZE.
	 */
	function processCacheObj(cacheObj) {
	  var arr = cacheObjToSortedArray(cacheObj);
	  arr.splice(UPDATES_CACHE_SIZE, Math.max(0, arr.length - UPDATES_CACHE_SIZE)).forEach(function (item) {
	    delete cacheObj[item.id];
	  });
	  return arr;
	}
	
	/**
	 * Lookup to filter out any items which appear in the updates feed which can't
	 * be displayed by the Updates component.
	 */
	var updateItemTypes = {
	  comment: true,
	  job: true,
	  poll: true,
	  story: true
	};
	
	/**
	 * Process incoming items from the update stream.
	 */
	function handleUpdateItems(items) {
	  for (var i = 0, l = items.length; i < l; i++) {
	    var item = items[i];
	    // Silently ignore deleted items (because irony)
	    if (item.deleted) {
	      continue;
	    }
	
	    if (typeof updateItemTypes[item.type] == 'undefined') {
	      if (false) {
	        console.warn("An item which can't be displayed by the Updates component was " + 'received in the updates stream: ' + JSON.stringify(item));
	      }
	      continue;
	    }
	
	    if (item.type === 'comment') {
	      updatesCache.comments[item.id] = item;
	    } else {
	      updatesCache.stories[item.id] = item;
	    }
	  }
	
	  populateUpdates();
	  UpdatesStore.emit('updates', updates);
	}
	
	var UpdatesStore = extend(new EventEmitter(), {
	  loadSession: function loadSession() {
	    var json = window.sessionStorage.updates;
	    updatesCache = json ? JSON.parse(json) : { comments: {}, stories: {} };
	    populateUpdates();
	  },
	
	  saveSession: function saveSession() {
	    window.sessionStorage.updates = JSON.stringify(updatesCache);
	  },
	
	  start: function start() {
	    if (updatesRef === null) {
	      updatesRef = HNService.updatesRef();
	      updatesRef.on('value', function (snapshot) {
	        HNService.fetchItems(snapshot.val(), handleUpdateItems);
	      });
	    }
	  },
	
	  stop: function stop() {
	    updatesRef.off();
	    updatesRef = null;
	  },
	
	  getUpdates: function getUpdates() {
	    return updates;
	  },
	
	  getItem: function getItem(id) {
	    return updatesCache.comments[id] || updatesCache.stories[id] || null;
	  },
	
	  getComment: function getComment(id) {
	    return updatesCache.comments[id] || null;
	  },
	
	  getStory: function getStory(id) {
	    return updatesCache.stories[id] || null;
	  }
	});
	UpdatesStore.off = UpdatesStore.removeListener;
	
	module.exports = UpdatesStore;

/***/ },
/* 41 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  ITEMS_PER_PAGE: 30,
	  SITE_TITLE: 'React HN',
	  UPDATES_CACHE_SIZE: 500
	};

/***/ },
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	var React = __webpack_require__(2);
	var Link = __webpack_require__(23);
	var TimeAgo = __webpack_require__(46)['default'];
	
	var ItemStore = __webpack_require__(91);
	var SettingsStore = __webpack_require__(8);
	
	var Spinner = __webpack_require__(21);
	
	var pluralise = __webpack_require__(34);
	
	var _ref = {
	  $$typeof: _typeofReactElement,
	  type: Spinner,
	  key: null,
	  ref: null,
	  props: _defaultProps(Spinner.defaultProps, {
	    size: '20'
	  }),
	  _owner: null
	};
	var _ref2 = {
	  $$typeof: _typeofReactElement,
	  type: 'div',
	  key: null,
	  ref: null,
	  props: {
	    children: 'Unable to load comment – this usually indicates the author has configured a delay. Trying again in 30 seconds.',
	    className: 'Comment__text'
	  },
	  _owner: null
	};
	var CommentMixin = {
	  fetchAncestors: function fetchAncestors(comment) {
	    var _this = this;
	
	    ItemStore.fetchCommentAncestors(comment, function (result) {
	      if (false) {
	        console.info('fetchAncestors(' + comment.id + ') took ' + result.timeTaken + ' ms for ' + result.itemCount + ' item' + pluralise(result.itemCount) + ' with ' + result.cacheHits + ' cache hit' + pluralise(result.cacheHits) + ' (' + (result.cacheHits / result.itemCount * 100).toFixed(1) + '%)');
	      }
	      if (!_this.isMounted()) {
	        if (false) {
	          console.info("...but the comment isn't mounted");
	        }
	        // Too late - the comment or the user has moved elsewhere
	        return;
	      }
	      _this.setState({
	        parent: result.parent,
	        op: result.op
	      });
	    });
	  },
	
	  renderCommentLoading: function renderCommentLoading(comment) {
	    return {
	      $$typeof: _typeofReactElement,
	      type: 'div',
	      key: null,
	      ref: null,
	      props: {
	        children: [(this.props.loadingSpinner || comment.delayed) && _ref, comment.delayed && _ref2],
	        className: 'Comment Comment--loading Comment--level' + this.props.level
	      },
	      _owner: null
	    };
	  },
	
	  renderCommentDeleted: function renderCommentDeleted(comment, options) {
	    return {
	      $$typeof: _typeofReactElement,
	      type: 'div',
	      key: null,
	      ref: null,
	      props: {
	        children: {
	          $$typeof: _typeofReactElement,
	          type: 'div',
	          key: null,
	          ref: null,
	          props: {
	            children: {
	              $$typeof: _typeofReactElement,
	              type: 'div',
	              key: null,
	              ref: null,
	              props: {
	                children: ['[deleted] | ', {
	                  $$typeof: _typeofReactElement,
	                  type: 'a',
	                  key: null,
	                  ref: null,
	                  props: {
	                    children: 'view on Hacker News',
	                    href: 'https://news.ycombinator.com/item?id=' + comment.id
	                  },
	                  _owner: null
	                }],
	                className: 'Comment__meta'
	              },
	              _owner: null
	            },
	            className: 'Comment__content'
	          },
	          _owner: null
	        },
	        className: options.className
	      },
	      _owner: null
	    };
	  },
	
	  renderError: function renderError(comment, options) {
	    return {
	      $$typeof: _typeofReactElement,
	      type: 'div',
	      key: null,
	      ref: null,
	      props: {
	        children: {
	          $$typeof: _typeofReactElement,
	          type: 'div',
	          key: null,
	          ref: null,
	          props: {
	            children: {
	              $$typeof: _typeofReactElement,
	              type: 'div',
	              key: null,
	              ref: null,
	              props: {
	                children: ['[error] | comment is ', JSON.stringify(comment), ' | ', {
	                  $$typeof: _typeofReactElement,
	                  type: 'a',
	                  key: null,
	                  ref: null,
	                  props: {
	                    children: 'view on Hacker News',
	                    href: 'https://news.ycombinator.com/item?id=' + options.id
	                  },
	                  _owner: null
	                }],
	                className: 'Comment__meta'
	              },
	              _owner: null
	            },
	            className: 'Comment__content'
	          },
	          _owner: null
	        },
	        className: options.className
	      },
	      _owner: null
	    };
	  },
	
	  renderCollapseControl: function renderCollapseControl(collapsed) {
	    return {
	      $$typeof: _typeofReactElement,
	      type: 'span',
	      key: null,
	      ref: null,
	      props: {
	        children: ['[', collapsed ? '+' : '–', ']'],
	        className: 'Comment__collapse',
	        onClick: this.toggleCollapse,
	        onKeyPress: this.toggleCollapse,
	        tabIndex: '0'
	      },
	      _owner: null
	    };
	  },
	
	  /**
	   * @param options.collapsible {Boolean} if true, assumes this.toggleCollspse()
	   * @param options.collapsed {Boolean}
	   * @param options.link {Boolean}
	   * @param options.parent {Boolean} if true, assumes this.state.parent
	   * @param options.op {Boolean} if true, assumes this.state.op
	   * @param options.childCounts {Object} with .children and .newComments
	   */
	  renderCommentMeta: function renderCommentMeta(comment, options) {
	    if (comment.dead && !SettingsStore.showDead) {
	      return {
	        $$typeof: _typeofReactElement,
	        type: 'div',
	        key: null,
	        ref: null,
	        props: {
	          children: [options.collapsible && this.renderCollapseControl(options.collapsed), options.collapsible && ' ', '[dead]', options.childCounts && ' | (' + options.childCounts.children + ' child' + pluralise(options.childCounts.children, ',ren'), options.childCounts && options.childCounts.newComments > 0 && ', ', options.childCounts && options.childCounts.newComments > 0 && {
	            $$typeof: _typeofReactElement,
	            type: 'em',
	            key: null,
	            ref: null,
	            props: {
	              children: [options.childCounts.newComments, ' new']
	            },
	            _owner: null
	          }, options.childCounts && ')'],
	          className: 'Comment__meta'
	        },
	        _owner: null
	      };
	    }
	
	    return {
	      $$typeof: _typeofReactElement,
	      type: 'div',
	      key: null,
	      ref: null,
	      props: {
	        children: [options.collapsible && this.renderCollapseControl(options.collapsed), options.collapsible && ' ', {
	          $$typeof: _typeofReactElement,
	          type: Link,
	          key: null,
	          ref: null,
	          props: _defaultProps(Link.defaultProps, {
	            children: comment.by,
	            to: '/user/' + comment.by,
	            className: 'Comment__user'
	          }),
	          _owner: null
	        }, ' ', {
	          $$typeof: _typeofReactElement,
	          type: TimeAgo,
	          key: null,
	          ref: null,
	          props: _defaultProps(TimeAgo.defaultProps, {
	            date: comment.time * 1000
	          }),
	          _owner: null
	        }, options.link && ' | ', options.link && {
	          $$typeof: _typeofReactElement,
	          type: Link,
	          key: null,
	          ref: null,
	          props: _defaultProps(Link.defaultProps, {
	            children: 'link',
	            to: '/comment/' + comment.id
	          }),
	          _owner: null
	        }, options.parent && ' | ', options.parent && {
	          $$typeof: _typeofReactElement,
	          type: Link,
	          key: null,
	          ref: null,
	          props: _defaultProps(Link.defaultProps, {
	            children: 'parent',
	            to: '/' + this.state.parent.type + '/' + comment.parent
	          }),
	          _owner: null
	        }, options.op && ' | on: ', options.op && {
	          $$typeof: _typeofReactElement,
	          type: Link,
	          key: null,
	          ref: null,
	          props: _defaultProps(Link.defaultProps, {
	            children: this.state.op.title,
	            to: '/' + this.state.op.type + '/' + this.state.op.id
	          }),
	          _owner: null
	        }, comment.dead && ' | [dead]', options.childCounts && {
	          $$typeof: _typeofReactElement,
	          type: 'span',
	          key: null,
	          ref: null,
	          props: {
	            children: [options.childCounts && ' | (' + options.childCounts.children + ' child' + pluralise(options.childCounts.children, ',ren'), options.childCounts && options.childCounts.newComments > 0 && ', ', options.childCounts && options.childCounts.newComments > 0 && {
	              $$typeof: _typeofReactElement,
	              type: 'em',
	              key: null,
	              ref: null,
	              props: {
	                children: [options.childCounts.newComments, ' new']
	              },
	              _owner: null
	            }, options.childCounts && ')'],
	            onClick: this.onCommentClick
	          },
	          _owner: null
	        }],
	        className: 'Comment__meta'
	      },
	      _owner: null
	    };
	  },
	
	  renderCommentText: function renderCommentText(comment, options) {
	    return {
	      $$typeof: _typeofReactElement,
	      type: 'div',
	      key: null,
	      ref: null,
	      props: {
	        children: [!comment.dead || SettingsStore.showDead ? {
	          $$typeof: _typeofReactElement,
	          type: 'div',
	          key: null,
	          ref: null,
	          props: {
	            dangerouslySetInnerHTML: { __html: comment.text }
	          },
	          _owner: null
	        } : '[dead]', SettingsStore.replyLinks && options.replyLink && !comment.dead && {
	          $$typeof: _typeofReactElement,
	          type: 'p',
	          key: null,
	          ref: null,
	          props: {
	            children: {
	              $$typeof: _typeofReactElement,
	              type: 'a',
	              key: null,
	              ref: null,
	              props: {
	                children: 'reply',
	                href: 'https://news.ycombinator.com/reply?id=' + comment.id
	              },
	              _owner: null
	            }
	          },
	          _owner: null
	        }],
	        className: 'Comment__text',
	        onClick: this.onCommentClick
	      },
	      _owner: null
	    };
	  }
	};
	
	module.exports = CommentMixin;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	var React = __webpack_require__(2);
	var Link = __webpack_require__(23);
	var TimeAgo = __webpack_require__(46)['default'];
	
	var SettingsStore = __webpack_require__(8);
	var pluralise = __webpack_require__(34);
	
	var parseHost = (function () {
	  var a = document.createElement('a');
	  return function (url) {
	    a.href = url;
	    var parts = a.hostname.split('.').slice(-3);
	    if (parts[0] === 'www') {
	      parts.shift();
	    }
	    return parts.join('.');
	  };
	})();
	
	/**
	 * Reusable logic for displaying an item.
	 */
	var ItemMixin = {
	  /**
	   * Render an item's metadata bar.
	   */
	  renderItemMeta: function renderItemMeta(item, extraContent) {
	    var itemDate = new Date(item.time * 1000);
	
	    if (item.type === 'job') {
	      return {
	        $$typeof: _typeofReactElement,
	        type: 'div',
	        key: null,
	        ref: null,
	        props: {
	          children: {
	            $$typeof: _typeofReactElement,
	            type: TimeAgo,
	            key: null,
	            ref: null,
	            props: _defaultProps(TimeAgo.defaultProps, {
	              date: itemDate,
	              className: 'Item__time'
	            }),
	            _owner: null
	          },
	          className: 'Item__meta'
	        },
	        _owner: null
	      };
	    }
	
	    return {
	      $$typeof: _typeofReactElement,
	      type: 'div',
	      key: null,
	      ref: null,
	      props: {
	        children: [{
	          $$typeof: _typeofReactElement,
	          type: 'span',
	          key: null,
	          ref: null,
	          props: {
	            children: [item.score, ' point', pluralise(item.score)],
	            className: 'Item__score'
	          },
	          _owner: null
	        }, ' ', {
	          $$typeof: _typeofReactElement,
	          type: 'span',
	          key: null,
	          ref: null,
	          props: {
	            children: ['by ', {
	              $$typeof: _typeofReactElement,
	              type: Link,
	              key: null,
	              ref: null,
	              props: _defaultProps(Link.defaultProps, {
	                children: item.by,
	                to: '/user/' + item.by
	              }),
	              _owner: null
	            }],
	            className: 'Item__by'
	          },
	          _owner: null
	        }, ' ', {
	          $$typeof: _typeofReactElement,
	          type: TimeAgo,
	          key: null,
	          ref: null,
	          props: _defaultProps(TimeAgo.defaultProps, {
	            date: itemDate,
	            className: 'Item__time'
	          }),
	          _owner: null
	        }, ' | ', {
	          $$typeof: _typeofReactElement,
	          type: Link,
	          key: null,
	          ref: null,
	          props: _defaultProps(Link.defaultProps, {
	            children: item.descendants > 0 ? item.descendants + ' comment' + pluralise(item.descendants) : 'discuss',
	            to: '/' + item.type + '/' + item.id
	          }),
	          _owner: null
	        }, extraContent],
	        className: 'Item__meta'
	      },
	      _owner: null
	    };
	  },
	
	  /**
	   * Render an item's title bar.
	   */
	  renderItemTitle: function renderItemTitle(item) {
	    var hasURL = !!item.url;
	    var title;
	    if (item.dead) {
	      title = '[dead] ' + item.title;
	    } else {
	      title = hasURL ? {
	        $$typeof: _typeofReactElement,
	        type: 'a',
	        key: null,
	        ref: null,
	        props: {
	          children: item.title,
	          href: item.url
	        },
	        _owner: null
	      } : {
	        $$typeof: _typeofReactElement,
	        type: Link,
	        key: null,
	        ref: null,
	        props: _defaultProps(Link.defaultProps, {
	          children: item.title,
	          to: '/' + item.type + '/' + item.id
	        }),
	        _owner: null
	      };
	    }
	    return {
	      $$typeof: _typeofReactElement,
	      type: 'div',
	      key: null,
	      ref: null,
	      props: {
	        children: [title, hasURL && ' ', hasURL && {
	          $$typeof: _typeofReactElement,
	          type: 'span',
	          key: null,
	          ref: null,
	          props: {
	            children: ['(', parseHost(item.url), ')'],
	            className: 'Item__host'
	          },
	          _owner: null
	        }],
	        className: 'Item__title',
	        style: { fontSize: SettingsStore.titleFontSize }
	      },
	      _owner: null
	    };
	  }
	};
	
	module.exports = ItemMixin;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var extend = __webpack_require__(33);
	
	function CommentThreadStore(item, onCommentsChanged) {
	  this.itemId = item.id;
	  this.onCommentsChanged = onCommentsChanged;
	
	  /**
	   * Lookup from a comment id to the comment.
	   * @type {Object.<id,Comment>}
	   */
	  this.comments = {};
	
	  /**
	   * Lookup from a comment id to its child comment ids.
	   * @type {Object.<id,Array.<Number>>}
	   */
	  this.children = {};
	  this.children[item.id] = [];
	
	  /**
	   * Lookup for new comment ids. Will only contain true.
	   * @type {Object.<id,Boolean>}
	   */
	  this.isNew = {};
	
	  /**
	   * Lookup for collapsed state of comment ids. May contain true or false.
	   * @type {Object.<id,Boolean>}
	   */
	  this.isCollapsed = {};
	
	  /**
	   * Lookup for dead comment ids
	   * @type {Object.<id,Boolean>}
	   */
	  this.deadComments = {};
	}
	
	extend(CommentThreadStore.prototype, {
	  /**
	   * Get counts of children and new comments under the given comment.
	   * @return .children {Number}
	   * @return .newComments {Number}
	   */
	  getChildCounts: function getChildCounts(comment) {
	    var childCount = 0;
	    var newCommentCount = 0;
	    var nodes = [comment.id];
	
	    while (nodes.length) {
	      var nextNodes = [];
	      for (var i = 0, l = nodes.length; i < l; i++) {
	        var nodeChildren = this.children[nodes[i]];
	        if (nodeChildren.length) {
	          nextNodes.push.apply(nextNodes, nodeChildren);
	        }
	      }
	      for (i = 0, l = nextNodes.length; i < l; i++) {
	        if (this.isNew[nextNodes[i]]) {
	          newCommentCount++;
	        }
	      }
	      childCount += nextNodes.length;
	      nodes = nextNodes;
	    }
	
	    return {
	      children: childCount,
	      newComments: newCommentCount
	    };
	  },
	
	  /**
	   * Register a comment's appearance in the thread.
	   */
	  commentAdded: function commentAdded(comment) {
	    if (comment.deleted) {
	      return;
	    }
	
	    this.comments[comment.id] = comment;
	    this.children[comment.id] = [];
	    this.children[comment.parent].push(comment.id);
	    if (comment.dead) {
	      this.deadComments[comment.id] = true;
	    }
	  },
	
	  /**
	   * Register a comment's deletion from the thread.
	   */
	  commentDeleted: function commentDeleted(comment) {
	    // Comments which initially failed to load (null from Firebase API) can be
	    // deleted by the time the API catches up.
	    if (!comment) {
	      return;
	    }
	
	    delete this.comments[comment.id];
	    var siblings = this.children[comment.parent];
	    siblings.splice(siblings.indexOf(comment.id), 1);
	    if (comment.dead) {
	      delete this.deadComments[comment.id];
	    }
	  },
	
	  toggleCollapse: function toggleCollapse(commentId) {
	    this.isCollapsed[commentId] = !this.isCollapsed[commentId];
	    this.onCommentsChanged({ type: 'collapse' });
	  }
	});
	
	module.exports = CommentThreadStore;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var CommentThreadStore = __webpack_require__(57);
	var SettingsStore = __webpack_require__(8);
	
	var debounce = __webpack_require__(154);
	var extend = __webpack_require__(33);
	var pluralise = __webpack_require__(34);
	var storage = __webpack_require__(93);
	
	/**
	 * Load persisted comment thread state.
	 * @return .lastVisit {Date} null if the item hasn't been visited before.
	 * @return .commentCount {Number} 0 if the item hasn't been visited before.
	 * @return .maxCommentId {Number} 0 if the item hasn't been visited before.
	 */
	function loadState(itemId) {
	  var json = storage.get(itemId);
	  if (json) {
	    return JSON.parse(json);
	  }
	  return {
	    lastVisit: null,
	    commentCount: 0,
	    maxCommentId: 0
	  };
	}
	
	function StoryCommentThreadStore(item, onCommentsChanged, options) {
	  CommentThreadStore.call(this, item, onCommentsChanged);
	  this.startedLoading = Date.now();
	
	  /** Lookup from a comment id to its parent comment id. */
	  this.parents = {};
	  /** The number of comments which have loaded. */
	  this.commentCount = 0;
	  /** The number of new comments which have loaded. */
	  this.newCommentCount = 0;
	  /** The max comment id seen by the store. */
	  this.maxCommentId = 0;
	  /** Has the comment thread finished loading? */
	  this.loading = true;
	  /** The number of comments we're expecting to load. */
	  this.expectedComments = item.kids ? item.kids.length : 0;
	  /**
	   * The number of descendants the story has according to the API.
	   * This count includes deleted comments, which aren't accessible via the API,
	   * so a thread with deleted comments (example story id: 9273709) will never
	   * load this number of comments
	   * However, we still need to persist the last known descendant count in order
	   * to determine how many new comments there are when displaying the story on a
	   * list page.
	   */
	  this.itemDescendantCount = item.descendants;
	
	  var initialState = loadState(item.id);
	  /** Time of last visit to the story. */
	  this.lastVisit = initialState.lastVisit;
	  /** Max comment id on the last visit - determines which comments are new. */
	  this.prevMaxCommentId = initialState.maxCommentId;
	  /** Is this the user's first time viewing the story? */
	  this.isFirstVisit = initialState.lastVisit === null;
	
	  // Trigger an immediate check for thread load completion if the item was not
	  // retrieved from the cache, so is the latest version. This completes page
	  // loading immediately for items which have no comments yet.
	  if (!options.cached) {
	    this.checkLoadCompletion();
	  }
	}
	
	StoryCommentThreadStore.loadState = loadState;
	
	StoryCommentThreadStore.prototype = extend(Object.create(CommentThreadStore.prototype), {
	  constructor: StoryCommentThreadStore,
	
	  /**
	   * Callback to the item component with updated comment counts, debounced as
	   * comments will be loading frequently on initial load.
	   */
	  numberOfCommentsChanged: debounce(function () {
	    this.onCommentsChanged({ type: 'number' });
	  }, 123),
	
	  /**
	   * If we don't have a last visit time stored for an item, it must have been
	   * visited for the first time. Once it finishes loading, establish the last
	   * visit time and max comment id which will be used to track and display new
	   * comments.
	   */
	  firstLoadComplete: function firstLoadComplete() {
	    this.lastVisit = Date.now();
	    this.prevMaxCommentId = this.maxCommentId;
	    this.isFirstVisit = false;
	    this.onCommentsChanged({ type: 'first_load_complete' });
	  },
	
	  /**
	   * Check whether the number of comments has reached the expected number yet.
	   */
	  checkLoadCompletion: function checkLoadCompletion() {
	    if (this.loading && this.commentCount >= this.expectedComments) {
	      if (false) {
	        console.info('Initial load of ' + this.commentCount + ' comment' + pluralise(this.commentCount) + ' for ' + this.itemId + ' took ' + ((Date.now() - this.startedLoading) / 1000).toFixed(2) + 's');
	      }
	      this.loading = false;
	      if (this.isFirstVisit) {
	        this.firstLoadComplete();
	      } else if (SettingsStore.autoCollapse && this.newCommentCount > 0) {
	        this.collapseThreadsWithoutNewComments();
	      }
	      this._storeState();
	    }
	  },
	
	  /**
	   * Persist comment thread state.
	   */
	  _storeState: function _storeState() {
	    storage.set(this.itemId, JSON.stringify({
	      lastVisit: Date.now(),
	      commentCount: this.itemDescendantCount,
	      maxCommentId: this.maxCommentId
	    }));
	  },
	
	  /**
	   * The item this comment thread belongs to got updated.
	   */
	  itemUpdated: function itemUpdated(item) {
	    this.itemDescendantCount = item.descendants;
	  },
	
	  /**
	   * A comment got loaded initially or added later.
	   */
	  commentAdded: function commentAdded(comment) {
	    // Deleted comments don't count towards the comment count
	    if (comment.deleted) {
	      // Adjust the number of comments expected during the initial page load.
	      if (this.loading) {
	        this.expectedComments--;
	        this.checkLoadCompletion();
	      }
	      return;
	    }
	
	    CommentThreadStore.prototype.commentAdded.call(this, comment);
	
	    // Dead comments don't contribute to the comment count if showDead is off
	    if (comment.dead && !SettingsStore.showDead) {
	      this.expectedComments--;
	    } else {
	      this.commentCount++;
	    }
	    // Add the number of kids the comment has to the expected total for the
	    // initial load.
	    if (this.loading && comment.kids) {
	      this.expectedComments += comment.kids.length;
	    }
	    // Register the comment as new if it's new, unless it's dead and showDead is off
	    if (this.prevMaxCommentId > 0 && comment.id > this.prevMaxCommentId && (!comment.dead || SettingsStore.showDead)) {
	      this.newCommentCount++;
	      this.isNew[comment.id] = true;
	    }
	    // Keep track of the biggest comment id seen
	    if (comment.id > this.maxCommentId) {
	      this.maxCommentId = comment.id;
	    }
	    // We don't want the story to be part of the comment parent hierarchy
	    if (comment.parent !== this.itemId) {
	      this.parents[comment.id] = comment.parent;
	    }
	
	    this.numberOfCommentsChanged();
	    if (this.loading) {
	      this.checkLoadCompletion();
	    }
	  },
	
	  /**
	   * A comment which hasn't loaded yet is being delayed.
	   */
	  commentDelayed: function commentDelayed(commentId) {
	    // Don't wait for delayed comments
	    this.expectedComments--;
	  },
	
	  /**
	   * A comment which wasn't previously deleted became deleted.
	   */
	  commentDeleted: function commentDeleted(comment) {
	    CommentThreadStore.prototype.commentDeleted.call(this, comment);
	    this.commentCount--;
	    if (this.isNew[comment.id]) {
	      this.newCommentCount--;
	      delete this.isNew[comment.id];
	    }
	    delete this.parents[comment.id];
	    // Trigger debounced callbacks
	    this.numberOfCommentsChanged();
	  },
	
	  /**
	   * A comment which wasn't previously dead became dead.
	   */
	  commentDied: function commentDied(comment) {
	    if (!SettingsStore.showDead) {
	      this.commentCount--;
	      if (this.isNew[comment.id]) {
	        this.newCommentCount--;
	        delete this.isNew[comment.id];
	      }
	    }
	  },
	
	  /**
	   * Change the expected number of comments if an update was received during
	   * initial loding and trigger a re-check of loading completion.
	   */
	  adjustExpectedComments: function adjustExpectedComments(change) {
	    this.expectedComments += change;
	    this.checkLoadCompletion();
	  },
	
	  collapseThreadsWithoutNewComments: function collapseThreadsWithoutNewComments() {
	    // Create an id lookup for comments which have a new comment as one of their
	    // descendants. New comments themselves are not added to the lookup.
	    var newCommentIds = Object.keys(this.isNew);
	    var hasNewComments = {};
	    for (var i = 0, l = newCommentIds.length; i < l; i++) {
	      var parent = this.parents[newCommentIds[i]];
	      while (parent) {
	        // Stop when we hit one we've seen before
	        if (hasNewComments[parent]) {
	          break;
	        }
	        hasNewComments[parent] = true;
	        parent = this.parents[parent];
	      }
	    }
	
	    // Walk the tree of comments one level at a time, only walking children to
	    // comments we know have new comment descendants, to find subtrees which
	    // don't have new comments.
	    // Other comments are marked for collapsing unless they are themselves a
	    // new comment (in which case all their replies must be new too).
	    var shouldCollapse = {};
	    var commentIds = this.children[this.itemId];
	    while (commentIds.length) {
	      var nextCommentIds = [];
	      for (i = 0, l = commentIds.length; i < l; i++) {
	        var commentId = commentIds[i];
	        if (!hasNewComments[commentId]) {
	          if (!this.isNew[commentId]) {
	            shouldCollapse[commentId] = true;
	          }
	        } else {
	          var childCommentIds = this.children[commentId];
	          if (childCommentIds.length) {
	            nextCommentIds.push.apply(nextCommentIds, childCommentIds);
	          }
	        }
	      }
	      commentIds = nextCommentIds;
	    }
	
	    this.isCollapsed = shouldCollapse;
	    this.onCommentsChanged({ type: 'collapse' });
	  },
	
	  getCommentByTimeIndex: function getCommentByTimeIndex(timeIndex) {
	    var _this = this;
	
	    var sortedCommentIds = Object.keys(this.comments).map(function (id) {
	      return Number(id);
	    });
	    if (!SettingsStore.showDead) {
	      sortedCommentIds = sortedCommentIds.filter(function (id) {
	        return !_this.deadComments[id];
	      });
	    }
	    sortedCommentIds.sort();
	    var commentId = sortedCommentIds[timeIndex - 1];
	    return this.comments[commentId];
	  },
	
	  highlightNewCommentsSince: function highlightNewCommentsSince(showCommentsAfter) {
	    var referenceComment = this.getCommentByTimeIndex(showCommentsAfter);
	
	    // Walk the tree of comments and create a new isNew lookup for comments
	    // newer than the reference comment we're using for highlighting.
	    var isNew = {};
	    var commentIds = this.children[this.itemId];
	    while (commentIds.length) {
	      var nextCommentIds = [];
	      for (var i = 0, l = commentIds.length; i < l; i++) {
	        var commentId = commentIds[i];
	        if (commentId > referenceComment.id) {
	          isNew[commentId] = true;
	        }
	        var childCommentIds = this.children[commentId];
	        if (childCommentIds.length) {
	          nextCommentIds.push.apply(nextCommentIds, childCommentIds);
	        }
	      }
	      commentIds = nextCommentIds;
	    }
	
	    this.isNew = isNew;
	    this.collapseThreadsWithoutNewComments();
	  },
	
	  /**
	   * Merk the thread as read.
	   */
	  markAsRead: function markAsRead() {
	    this.lastVisit = Date.now();
	    this.newCommentCount = 0;
	    this.prevMaxCommentId = this.maxCommentId;
	    this.isNew = {};
	    this._storeState();
	  },
	
	  /**
	   * Persist comment thread state and perform any necessary internal cleanup.
	   */
	  dispose: function dispose() {
	    // Cancel debounced callbacks in case any are pending
	    this.numberOfCommentsChanged.cancel();
	    this._storeState();
	  }
	});
	
	module.exports = StoryCommentThreadStore;

/***/ },
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	var React = __webpack_require__(2);
	var ReactFireMixin = __webpack_require__(31);
	
	var CommentThreadStore = __webpack_require__(57);
	var HNService = __webpack_require__(14);
	var SettingsStore = __webpack_require__(8);
	
	var CommentMixin = __webpack_require__(55);
	
	var cx = __webpack_require__(32);
	
	/**
	 * A comment in a thread.
	 */
	var Comment = React.createClass({
	  displayName: 'Comment',
	
	  mixins: [CommentMixin, ReactFireMixin],
	
	  propTypes: {
	    id: React.PropTypes.number.isRequired,
	    level: React.PropTypes.number.isRequired,
	    loadingSpinner: React.PropTypes.bool,
	    threadStore: React.PropTypes.instanceOf(CommentThreadStore).isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      loadingSpinner: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      comment: {}
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.bindFirebaseRef();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.clearDelayTimeout();
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    // Huge, fast-growing threads like https://news.ycombinator.com/item?id=9784470
	    // seem to break the API - some comments are coming back from Firebase as null.
	    if (!this.state.comment) {
	      this.props.threadStore.adjustExpectedComments(-1);
	      return;
	    }
	
	    // On !prevState.comment: a comment which was initially null - see
	    // above - may eventually load when the API catches up.
	    if (!prevState.comment || !prevState.comment.id) {
	      // Register a newly-loaded comment with the thread store
	      if (this.state.comment.id) {
	        // If the comment was delayed, cancel any pending timeout
	        if (prevState.comment && prevState.comment.delayed) {
	          this.clearDelayTimeout();
	        }
	        this.props.threadStore.commentAdded(this.state.comment);
	      }
	      if (prevState.comment && !prevState.comment.delayed && this.state.comment.delayed) {
	        this.props.threadStore.commentDelayed(this.props.id);
	      }
	    }
	    // The comment was already loaded, look for changes to it
	    else {
	        if (!prevState.comment.deleted && this.state.comment.deleted) {
	          this.props.threadStore.commentDeleted(this.state.comment);
	        }
	        if (!prevState.comment.dead && this.state.comment.dead) {
	          this.props.threadStore.commentDied(this.state.comment);
	        }
	        // If the comment has been updated and the initial set of comments is
	        // still loading, the number of expected comments might need to be
	        // adjusted.
	        else if (prevState.comment !== this.state.comment && this.props.threadStore.loading) {
	            var kids = this.state.comment.kids ? this.state.comment.kids.length : 0;
	            var prevKids = prevState.comment.kids ? prevState.comment.kids.length : 0;
	            this.props.threadStore.adjustExpectedComments(kids - prevKids);
	          }
	      }
	  },
	
	  bindFirebaseRef: function bindFirebaseRef() {
	    this.bindAsObject(HNService.itemRef(this.props.id), 'comment', this.handleFirebaseRefCancelled);
	    if (this.timeout) {
	      this.timeout = null;
	    }
	  },
	
	  /**
	   * This is usually caused by a permissions error loading the comment due to
	   * its author using the delay setting (note: this is conjecture), which is
	   * measured in minutes - try again in 30 seconds.
	   */
	  handleFirebaseRefCancelled: function handleFirebaseRefCancelled(e) {
	    if (false) {
	      console.error('Firebase ref for comment ' + this.props.id + ' was cancelled: ' + e.message);
	    }
	    this.unbind('comment');
	    this.timeout = setTimeout(this.bindFirebaseRef, 30000);
	    if (this.state.comment && !this.state.comment.delayed) {
	      this.state.comment.delayed = true;
	      this.forceUpdate();
	    }
	  },
	
	  clearDelayTimeout: function clearDelayTimeout() {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	      this.timeout = null;
	    }
	  },
	
	  onCommentClick: function onCommentClick(e) {
	    if (e.target.tagName !== 'A') {
	      this.toggleCollapse(e);
	    } else {
	      e.preventDefault();
	      window.open(e.target.href, '_blank');
	    }
	  },
	
	  toggleCollapse: function toggleCollapse(e) {
	    e.preventDefault();
	    this.props.threadStore.toggleCollapse(this.state.comment.id);
	  },
	
	  render: function render() {
	    var comment = this.state.comment;
	    var props = this.props;
	    if (!comment) {
	      return this.renderError(comment, {
	        id: this.props.id,
	        className: 'Comment Comment--error Comment--level' + props.level
	      });
	    }
	    // Render a placeholder while we're waiting for the comment to load
	    if (!comment.id) {
	      return this.renderCommentLoading(comment);
	    }
	    // Don't show dead coments or their children, when configured
	    if (comment.dead && !SettingsStore.showDead) {
	      return null;
	    }
	    // Render a link to HN for deleted comments if they're being displayed
	    if (comment.deleted) {
	      if (!SettingsStore.showDeleted) {
	        return null;
	      }
	      return this.renderCommentDeleted(comment, {
	        className: 'Comment Comment--deleted Comment--level' + props.level
	      });
	    }
	
	    var isNew = props.threadStore.isNew[comment.id];
	    var collapsed = !!props.threadStore.isCollapsed[comment.id];
	    var childCounts = collapsed && props.threadStore.getChildCounts(comment);
	    if (collapsed && isNew) {
	      childCounts.newComments = 0;
	    }
	    var className = cx('Comment Comment--level' + props.level, {
	      'Comment--collapsed': collapsed,
	      'Comment--dead': comment.dead,
	      'Comment--new': isNew
	    });
	
	    return {
	      $$typeof: _typeofReactElement,
	      type: 'div',
	      key: null,
	      ref: null,
	      props: {
	        children: [{
	          $$typeof: _typeofReactElement,
	          type: 'div',
	          key: null,
	          ref: null,
	          props: {
	            children: [this.renderCommentMeta(comment, {
	              collapsible: true,
	              collapsed: collapsed,
	              link: true,
	              childCounts: childCounts
	            }), this.renderCommentText(comment, { replyLink: true })],
	            className: 'Comment__content'
	          },
	          _owner: null
	        }, comment.kids && {
	          $$typeof: _typeofReactElement,
	          type: 'div',
	          key: null,
	          ref: null,
	          props: {
	            children: comment.kids.map(function (id) {
	              return {
	                $$typeof: _typeofReactElement,
	                type: Comment,
	                key: id,
	                ref: null,
	                props: _defaultProps(Comment.defaultProps, {
	                  id: id,
	                  level: props.level + 1,
	                  loadingSpinner: props.loadingSpinner,
	                  threadStore: props.threadStore
	                }),
	                _owner: null
	              };
	            }),
	            className: 'Comment__kids'
	          },
	          _owner: null
	        }],
	        className: className
	      },
	      _owner: null
	    };
	  }
	});
	
	module.exports = Comment;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	var React = __webpack_require__(2);
	var Link = __webpack_require__(23);
	
	var Paginator = React.createClass({
	  displayName: 'Paginator',
	
	  _onClick: function _onClick(e) {
	    setTimeout(function () {
	      window.scrollTo(0, 0);
	    }, 0);
	  },
	
	  render: function render() {
	    if (this.props.page === 1 && !this.props.hasNext) {
	      return null;
	    }
	    return {
	      $$typeof: _typeofReactElement,
	      type: 'div',
	      key: null,
	      ref: null,
	      props: {
	        children: [this.props.page > 1 && {
	          $$typeof: _typeofReactElement,
	          type: 'span',
	          key: null,
	          ref: null,
	          props: {
	            children: {
	              $$typeof: _typeofReactElement,
	              type: Link,
	              key: null,
	              ref: null,
	              props: _defaultProps(Link.defaultProps, {
	                children: 'Prev',
	                to: { pathname: '/' + this.props.route, query: { page: this.props.page - 1 } },
	                onClick: this._onClick
	              }),
	              _owner: null
	            },
	            className: 'Paginator__prev'
	          },
	          _owner: null
	        }, this.props.page > 1 && this.props.hasNext && ' | ', this.props.hasNext && {
	          $$typeof: _typeofReactElement,
	          type: 'span',
	          key: null,
	          ref: null,
	          props: {
	            children: {
	              $$typeof: _typeofReactElement,
	              type: Link,
	              key: null,
	              ref: null,
	              props: _defaultProps(Link.defaultProps, {
	                children: 'More',
	                to: { pathname: '/' + this.props.route, query: { page: this.props.page + 1 } },
	                onClick: this._onClick
	              }),
	              _owner: null
	            },
	            className: 'Paginator__next'
	          },
	          _owner: null
	        }],
	        className: 'Paginator'
	      },
	      _owner: null
	    };
	  }
	});
	
	module.exports = Paginator;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	var React = __webpack_require__(2);
	var Link = __webpack_require__(23);
	
	var SettingsStore = __webpack_require__(8);
	var cx = __webpack_require__(32);
	
	/**
	 * Reusable logic for displaying an item in a list.
	 * Must be used in conjunction with ItemMixin for its rendering methods.
	 */
	var ListItemMixin = {
	  getNewCommentCount: function getNewCommentCount(item, threadState) {
	    if (threadState.lastVisit === null) {
	      return 0;
	    }
	    return item.descendants - threadState.commentCount;
	  },
	
	  renderListItem: function renderListItem(item, threadState) {
	    if (item.deleted) {
	      return null;
	    }
	    var newCommentCount = this.getNewCommentCount(item, threadState);
	    return {
	      $$typeof: _typeofReactElement,
	      type: 'li',
	      key: null,
	      ref: null,
	      props: {
	        children: [this.renderItemTitle(item), this.renderItemMeta(item, newCommentCount > 0 && {
	          $$typeof: _typeofReactElement,
	          type: 'span',
	          key: null,
	          ref: null,
	          props: {
	            children: [' ', '(', {
	              $$typeof: _typeofReactElement,
	              type: Link,
	              key: null,
	              ref: null,
	              props: _defaultProps(Link.defaultProps, {
	                children: [newCommentCount, ' new'],
	                to: '/' + item.type + '/' + item.id
	              }),
	              _owner: null
	            }, ')'],
	            className: 'ListItem__newcomments'
	          },
	          _owner: null
	        })],
	        className: cx('ListItem', { 'ListItem--dead': item.dead }),
	        style: { marginBottom: SettingsStore.listSpacing }
	      },
	      _owner: null
	    };
	  }
	};
	
	module.exports = ListItemMixin;

/***/ },
/* 90 */
/***/ function(module, exports) {

	'use strict';
	
	var PageNumberMixin = {
	  getPageNumber: function getPageNumber(page) {
	    if (typeof page == 'undefined') {
	      page = this.props.location.query.page;
	    }
	    return page && /^\d+$/.test(page) ? Math.max(1, Number(page)) : 1;
	  }
	};
	
	module.exports = PageNumberMixin;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {'use strict';
	
	var HNService = __webpack_require__(14);
	
	var StoryStore = __webpack_require__(39);
	var UpdatesStore = __webpack_require__(40);
	
	var commentParentLookup = {};
	var titleCache = {};
	
	function fetchCommentParent(comment, cb, result) {
	  var commentId = comment.id;
	  var parentId = comment.parent;
	
	  while (commentParentLookup[parentId] || titleCache[parentId]) {
	    // We just saved ourselves an item fetch
	    result.itemCount++;
	    result.cacheHits++;
	
	    // The parent is a known non-comment
	    if (titleCache[parentId]) {
	      if (result.itemCount === 1) {
	        result.parent = titleCache[parentId];
	      }
	      result.op = titleCache[parentId];
	      cb(result);
	      return;
	    }
	
	    // The parent is a known comment
	    if (commentParentLookup[parentId]) {
	      if (result.itemCount === 1) {
	        result.parent = { id: parentId, type: 'comment' };
	      }
	      // Set the parent comment's ids up for the next iteration
	      commentId = parentId;
	      parentId = commentParentLookup[parentId];
	    }
	  }
	
	  // The parent of the current comment isn't known, so we'll have to fetch it
	  ItemStore.getItem(parentId, function (parent) {
	    result.itemCount++;
	    // Add the current comment's parent to the lookup for next time
	    commentParentLookup[commentId] = parentId;
	    if (parent.type === 'comment') {
	      commentParentLookup[parent.id] = parent.parent;
	    }
	    processCommentParent(parent, cb, result);
	  }, result);
	}
	
	function processCommentParent(item, cb, result) {
	  if (result.itemCount === 1) {
	    result.parent = item;
	  }
	  if (item.type !== 'comment') {
	    result.op = item;
	    titleCache[item.id] = {
	      id: item.id,
	      type: item.type,
	      title: item.title
	    };
	    cb(result);
	  } else {
	    fetchCommentParent(item, cb, result);
	  }
	}
	
	var ItemStore = {
	  getItem: function getItem(id, cb, result) {
	    var cachedItem = this.getCachedItem(id);
	    if (cachedItem) {
	      if (result) {
	        result.cacheHits++;
	      }
	      setImmediate(cb, cachedItem);
	    } else {
	      HNService.fetchItem(id, cb);
	    }
	  },
	
	  getCachedItem: function getCachedItem(id) {
	    return StoryStore.getItem(id) || UpdatesStore.getItem(id) || null;
	  },
	
	  getCachedStory: function getCachedStory(id) {
	    return StoryStore.getItem(id) || UpdatesStore.getStory(id) || null;
	  },
	
	  fetchCommentAncestors: function fetchCommentAncestors(comment, cb) {
	    var startTime = Date.now();
	    var result = { itemCount: 0, cacheHits: 0 };
	    fetchCommentParent(comment, function () {
	      result.timeTaken = Date.now() - startTime;
	      setImmediate(cb, result);
	    }, result);
	  }
	};
	
	module.exports = ItemStore;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54).setImmediate))

/***/ },
/* 92 */
/***/ function(module, exports) {

	"use strict";
	
	function pageCalc(pageNum, pageSize, numItems) {
	  var startIndex = (pageNum - 1) * pageSize;
	  var endIndex = Math.min(numItems, startIndex + pageSize);
	  var hasNext = endIndex < numItems - 1;
	  return { pageNum: pageNum, startIndex: startIndex, endIndex: endIndex, hasNext: hasNext };
	}
	
	module.exports = pageCalc;

/***/ },
/* 93 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  get: function get(key, defaultValue) {
	    var value = window.localStorage[key];
	    return typeof value != 'undefined' ? value : defaultValue;
	  },
	  set: function set(key, value) {
	    window.localStorage[key] = value;
	  }
	};

/***/ },
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/* global __VERSION__ */
	'use strict';
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	var React = __webpack_require__(2);
	var Link = __webpack_require__(23);
	
	var Settings = __webpack_require__(148);
	
	var StoryStore = __webpack_require__(39);
	var UpdatesStore = __webpack_require__(40);
	var SettingsStore = __webpack_require__(8);
	
	var _ref = {
	  $$typeof: _typeofReactElement,
	  type: Link,
	  key: null,
	  ref: null,
	  props: _defaultProps(Link.defaultProps, {
	    children: {
	      $$typeof: _typeofReactElement,
	      type: 'img',
	      key: null,
	      ref: null,
	      props: {
	        src: 'img/logo.png',
	        width: '16',
	        height: '16',
	        alt: ''
	      },
	      _owner: null
	    },
	    to: '/news',
	    className: 'App__homelinkicon'
	  }),
	  _owner: null
	};
	var _ref2 = {
	  $$typeof: _typeofReactElement,
	  type: Link,
	  key: null,
	  ref: null,
	  props: _defaultProps(Link.defaultProps, {
	    children: 'React HN',
	    to: '/news',
	    activeClassName: 'active',
	    className: 'App__homelink'
	  }),
	  _owner: null
	};
	var _ref3 = {
	  $$typeof: _typeofReactElement,
	  type: Link,
	  key: null,
	  ref: null,
	  props: _defaultProps(Link.defaultProps, {
	    children: 'new',
	    to: '/newest',
	    activeClassName: 'active'
	  }),
	  _owner: null
	};
	var _ref4 = {
	  $$typeof: _typeofReactElement,
	  type: Link,
	  key: null,
	  ref: null,
	  props: _defaultProps(Link.defaultProps, {
	    children: 'comments',
	    to: '/newcomments',
	    activeClassName: 'active'
	  }),
	  _owner: null
	};
	var _ref5 = {
	  $$typeof: _typeofReactElement,
	  type: Link,
	  key: null,
	  ref: null,
	  props: _defaultProps(Link.defaultProps, {
	    children: 'show',
	    to: '/show',
	    activeClassName: 'active'
	  }),
	  _owner: null
	};
	var _ref6 = {
	  $$typeof: _typeofReactElement,
	  type: Link,
	  key: null,
	  ref: null,
	  props: _defaultProps(Link.defaultProps, {
	    children: 'ask',
	    to: '/ask',
	    activeClassName: 'active'
	  }),
	  _owner: null
	};
	var _ref7 = {
	  $$typeof: _typeofReactElement,
	  type: Link,
	  key: null,
	  ref: null,
	  props: _defaultProps(Link.defaultProps, {
	    children: 'jobs',
	    to: '/jobs',
	    activeClassName: 'active'
	  }),
	  _owner: null
	};
	var _ref8 = {
	  $$typeof: _typeofReactElement,
	  type: Settings,
	  key: 'settings',
	  ref: null,
	  props: _defaultProps(Settings.defaultProps, {}),
	  _owner: null
	};
	var _ref9 = {
	  $$typeof: _typeofReactElement,
	  type: 'a',
	  key: null,
	  ref: null,
	  props: {
	    children: 'insin/react-hn',
	    href: 'https://github.com/insin/react-hn'
	  },
	  _owner: null
	};
	var App = React.createClass({
	  displayName: 'App',
	
	  getInitialState: function getInitialState() {
	    return {
	      showSettings: false
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    SettingsStore.load();
	    StoryStore.loadSession();
	    UpdatesStore.loadSession();
	    window.addEventListener('beforeunload', this.handleBeforeUnload);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener('beforeunload', this.handleBeforeUnload);
	  },
	
	  /**
	   * Give stores a chance to persist data to sessionStorage in case this is a
	   * refresh or an external link in the same tab.
	   */
	  handleBeforeUnload: function handleBeforeUnload() {
	    StoryStore.saveSession();
	    UpdatesStore.saveSession();
	  },
	
	  toggleSettings: function toggleSettings(e) {
	    e.preventDefault();
	    this.setState({ showSettings: !this.state.showSettings });
	  },
	
	  render: function render() {
	    var isMediaDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
	    var enableDarkMode = SettingsStore.darkThemeMode === 'dark' || SettingsStore.darkThemeMode === 'auto' && isMediaDarkMode;
	    return {
	      $$typeof: _typeofReactElement,
	      type: 'div',
	      key: null,
	      ref: null,
	      props: {
	        children: {
	          $$typeof: _typeofReactElement,
	          type: 'div',
	          key: null,
	          ref: null,
	          props: {
	            children: [{
	              $$typeof: _typeofReactElement,
	              type: 'div',
	              key: null,
	              ref: null,
	              props: {
	                children: [_ref, ' ', _ref2, ' ', _ref3, ' | ', _ref4, ' ', ' | ', _ref5, ' | ', _ref6, ' | ', _ref7, {
	                  $$typeof: _typeofReactElement,
	                  type: 'a',
	                  key: null,
	                  ref: null,
	                  props: {
	                    children: this.state.showSettings ? 'hide settings' : 'settings',
	                    className: 'App__settings',
	                    tabIndex: '0',
	                    onClick: this.toggleSettings,
	                    onKeyPress: this.toggleSettings
	                  },
	                  _owner: null
	                }, this.state.showSettings && _ref8],
	                className: 'App__header'
	              },
	              _owner: null
	            }, {
	              $$typeof: _typeofReactElement,
	              type: 'div',
	              key: null,
	              ref: null,
	              props: {
	                children: this.props.children,
	                className: 'App__content'
	              },
	              _owner: null
	            }, {
	              $$typeof: _typeofReactElement,
	              type: 'div',
	              key: null,
	              ref: null,
	              props: {
	                children: ['react-hn v' + ("1.4.12") + ' | ', _ref9],
	                className: 'App__footer'
	              },
	              _owner: null
	            }],
	            className: enableDarkMode ? 'Dark__app__wrap App__wrap' : 'App__wrap'
	          },
	          _owner: null
	        },
	        className: enableDarkMode ? 'Dark__app__wrap App' : 'App',
	        onClick: this.state.showSettings && this.toggleSettings
	      },
	      _owner: null
	    };
	  }
	});
	
	module.exports = App;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	var React = __webpack_require__(2);
	
	var SettingsStore = __webpack_require__(8);
	
	var CommentMixin = __webpack_require__(55);
	
	var cx = __webpack_require__(32);
	
	/**
	 * Displays a standalone comment passed as a prop.
	 */
	var DisplayComment = React.createClass({
	  displayName: 'DisplayComment',
	
	  mixins: [CommentMixin],
	
	  propTypes: {
	    comment: React.PropTypes.object.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      op: {},
	      parent: { type: 'comment' }
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchAncestors(this.props.comment);
	  },
	
	  render: function render() {
	    if (this.props.comment.deleted) {
	      return null;
	    }
	    if (this.props.comment.dead && !SettingsStore.showDead) {
	      return null;
	    }
	
	    var comment = this.props.comment;
	    var className = cx('Comment Comment--level0', {
	      'Comment--dead': comment.dead
	    });
	
	    return {
	      $$typeof: _typeofReactElement,
	      type: 'div',
	      key: null,
	      ref: null,
	      props: {
	        children: {
	          $$typeof: _typeofReactElement,
	          type: 'div',
	          key: null,
	          ref: null,
	          props: {
	            children: [this.renderCommentMeta(comment, {
	              link: true,
	              parent: !!this.state.parent.id && !!this.state.op.id && comment.parent !== this.state.op.id,
	              op: !!this.state.op.id
	            }), this.renderCommentText(comment, { replyLink: false })],
	            className: 'Comment__content'
	          },
	          _owner: null
	        },
	        className: className
	      },
	      _owner: null
	    };
	  }
	});
	
	module.exports = DisplayComment;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(2);
	
	var StoryCommentThreadStore = __webpack_require__(58);
	
	var ItemMixin = __webpack_require__(56);
	var ListItemMixin = __webpack_require__(89);
	
	/**
	 * Display story title and metadata as a list item.
	 * The story to display will be passed as a prop.
	 */
	var DisplayListItem = React.createClass({
	  displayName: 'DisplayListItem',
	
	  mixins: [ItemMixin, ListItemMixin],
	
	  propTypes: {
	    item: React.PropTypes.object.isRequired
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.threadState = StoryCommentThreadStore.loadState(this.props.item.id);
	  },
	
	  render: function render() {
	    return this.renderListItem(this.props.item, this.threadState);
	  }
	});
	
	module.exports = DisplayListItem;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	var React = __webpack_require__(2);
	var ReactFireMixin = __webpack_require__(31);
	var TimeAgo = __webpack_require__(46)['default'];
	
	var HNService = __webpack_require__(14);
	var StoryCommentThreadStore = __webpack_require__(58);
	var ItemStore = __webpack_require__(91);
	
	var Comment = __webpack_require__(87);
	var PollOption = __webpack_require__(147);
	var Spinner = __webpack_require__(21);
	var ItemMixin = __webpack_require__(56);
	
	var cx = __webpack_require__(32);
	var setTitle = __webpack_require__(35);
	var pluralise = __webpack_require__(34);
	
	function timeUnitsAgo(value, unit, suffix) {
	  if (value === 1) {
	    return unit;
	  }
	  return value + ' ' + unit + 's';
	}
	
	var _ref = {
	  $$typeof: _typeofReactElement,
	  type: 'div',
	  key: null,
	  ref: null,
	  props: {
	    children: {
	      $$typeof: _typeofReactElement,
	      type: Spinner,
	      key: null,
	      ref: null,
	      props: _defaultProps(Spinner.defaultProps, {
	        size: '20'
	      }),
	      _owner: null
	    },
	    className: 'Item Item--loading'
	  },
	  _owner: null
	};
	var Item = React.createClass({
	  displayName: 'Item',
	
	  mixins: [ItemMixin, ReactFireMixin],
	
	  getInitialState: function getInitialState() {
	    return {
	      item: ItemStore.getCachedStory(Number(this.props.params.id)) || {}
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.bindAsObject(HNService.itemRef(this.props.params.id), 'item');
	    if (this.state.item.id) {
	      this.threadStore = new StoryCommentThreadStore(this.state.item, this.handleCommentsChanged, { cached: true });
	      setTitle(this.state.item.title);
	    }
	    window.addEventListener('beforeunload', this.handleBeforeUnload);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.threadStore) {
	      this.threadStore.dispose();
	    }
	    window.removeEventListener('beforeunload', this.handleBeforeUnload);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.params.id !== nextProps.params.id) {
	      // Tear it down...
	      this.threadStore.dispose();
	      this.threadStore = null;
	      this.unbind('item');
	      // ...and set it up again
	      var item = ItemStore.getCachedStory(Number(nextProps.params.id));
	      if (item) {
	        this.threadStore = new StoryCommentThreadStore(item, this.handleCommentsChanged, { cached: true });
	        setTitle(item.title);
	      }
	      this.bindAsObject(HNService.itemRef(nextProps.params.id), 'item');
	      this.setState({ item: item || {} });
	    }
	  },
	
	  componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
	    // Update the title when the item has loaded.
	    if (!this.state.item.id && nextState.item.id) {
	      setTitle(nextState.item.title);
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    // If the state item id changed, an initial or new item must have loaded
	    if (prevState.item.id !== this.state.item.id) {
	      if (!this.threadStore || this.threadStore.itemId !== this.state.item.id) {
	        this.threadStore = new StoryCommentThreadStore(this.state.item, this.handleCommentsChanged, { cached: false });
	        setTitle(this.state.item.title);
	        this.forceUpdate();
	      }
	    } else if (prevState.item !== this.state.item) {
	      // If the item has been updated from Firebase and the initial set
	      // of comments is still loading, the number of expected comments might
	      // need to be adjusted.
	      // This triggers a check for thread load completion, completing it
	      // immediately if a cached item had 0 kids and the latest version from
	      // Firebase also has 0 kids.
	      if (this.threadStore.loading) {
	        var kids = this.state.item.kids ? this.state.item.kids.length : 0;
	        var prevKids = prevState.item.kids ? prevState.item.kids.length : 0;
	        var kidDiff = kids - prevKids;
	        if (kidDiff !== 0) {
	          this.threadStore.adjustExpectedComments(kidDiff);
	        }
	      }
	      this.threadStore.itemUpdated(this.state.item);
	    }
	  },
	
	  /**
	   * Ensure the last visit time and comment details get stored for this item if
	   * the user refreshes or otherwise navigates off the page.
	   */
	  handleBeforeUnload: function handleBeforeUnload() {
	    if (this.threadStore) {
	      this.threadStore.dispose();
	    }
	  },
	
	  handleCommentsChanged: function handleCommentsChanged(payload) {
	    this.forceUpdate();
	  },
	
	  autoCollapse: function autoCollapse(e) {
	    e.preventDefault();
	    this.threadStore.collapseThreadsWithoutNewComments();
	  },
	
	  markAsRead: function markAsRead(e) {
	    e.preventDefault();
	    this.threadStore.markAsRead();
	    this.forceUpdate();
	  },
	
	  getButtonLabel: function getButtonLabel() {
	    var showCommentsAfter = this.state.showNewCommentsAfter || this.threadStore.commentCount - 1;
	    var howMany = this.threadStore.commentCount - showCommentsAfter;
	    var timeComment = this.threadStore.getCommentByTimeIndex(showCommentsAfter + 1);
	    var text = 'highlight ' + howMany + ' comment' + pluralise(howMany) + ' from ';
	    return {
	      $$typeof: _typeofReactElement,
	      type: 'span',
	      key: null,
	      ref: null,
	      props: {
	        children: [text, timeComment && {
	          $$typeof: _typeofReactElement,
	          type: TimeAgo,
	          key: null,
	          ref: null,
	          props: _defaultProps(TimeAgo.defaultProps, {
	            date: new Date(timeComment.time * 1000)
	          }),
	          _owner: null
	        }]
	      },
	      _owner: null
	    };
	  },
	
	  highlightRecentComments: function highlightRecentComments() {
	    var showCommentsAfter = this.state.showNewCommentsAfter || this.threadStore.commentCount - 1;
	    this.threadStore.highlightNewCommentsSince(showCommentsAfter);
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var state = this.state;
	    var item = state.item;
	    var threadStore = this.threadStore;
	    if (!item.id || !threadStore) {
	      return _ref;
	    }
	    return {
	      $$typeof: _typeofReactElement,
	      type: 'div',
	      key: null,
	      ref: null,
	      props: {
	        children: [{
	          $$typeof: _typeofReactElement,
	          type: 'div',
	          key: null,
	          ref: null,
	          props: {
	            children: [this.renderItemTitle(item), this.renderItemMeta(item, threadStore.lastVisit !== null && threadStore.newCommentCount > 0 && {
	              $$typeof: _typeofReactElement,
	              type: 'span',
	              key: null,
	              ref: null,
	              props: {
	                children: [' ', '(', {
	                  $$typeof: _typeofReactElement,
	                  type: 'em',
	                  key: null,
	                  ref: null,
	                  props: {
	                    children: [threadStore.newCommentCount, ' new']
	                  },
	                  _owner: null
	                }, ' in the last ', {
	                  $$typeof: _typeofReactElement,
	                  type: TimeAgo,
	                  key: null,
	                  ref: null,
	                  props: _defaultProps(TimeAgo.defaultProps, {
	                    date: threadStore.lastVisit,
	                    formatter: timeUnitsAgo
	                  }),
	                  _owner: null
	                }, ') | ', {
	                  $$typeof: _typeofReactElement,
	                  type: 'span',
	                  key: null,
	                  ref: null,
	                  props: {
	                    children: 'auto collapse',
	                    className: 'control',
	                    tabIndex: '0',
	                    onClick: this.autoCollapse,
	                    onKeyPress: this.autoCollapse,
	                    title: 'Collapse threads without new comments'
	                  },
	                  _owner: null
	                }, ' | ', {
	                  $$typeof: _typeofReactElement,
	                  type: 'span',
	                  key: null,
	                  ref: null,
	                  props: {
	                    children: 'mark as read',
	                    className: 'control',
	                    tabIndex: '0',
	                    onClick: this.markAsRead,
	                    onKeyPress: this.markAsRead
	                  },
	                  _owner: null
	                }]
	              },
	              _owner: null
	            }), {
	              $$typeof: _typeofReactElement,
	              type: 'div',
	              key: null,
	              ref: null,
	              props: {
	                children: [{
	                  $$typeof: _typeofReactElement,
	                  type: 'input',
	                  key: null,
	                  ref: null,
	                  props: {
	                    max: threadStore.commentCount - 1,
	                    min: 1,
	                    style: { margin: 0, verticalAlign: 'middle' },
	                    type: 'range',
	                    value: state.showNewCommentsAfter || threadStore.commentCount - 1,
	                    onChange: function (e) {
	                      var showNewCommentsAfter = Number(e.target.value);
	                      _this.setState({ showNewCommentsAfter: showNewCommentsAfter });
	                    }
	                  },
	                  _owner: null
	                }, {
	                  $$typeof: _typeofReactElement,
	                  type: 'button',
	                  key: null,
	                  ref: null,
	                  props: {
	                    children: this.getButtonLabel(),
	                    type: 'button',
	                    onClick: this.highlightRecentComments
	                  },
	                  _owner: null
	                }],
	                style: {
	                  marginTop: '1em', opacity: !threadStore.loading && threadStore.commentCount > 1 ? 1.0 : 0.0,
	                  transition: 'opacity .33s ease-out'
	                }
	              },
	              _owner: null
	            }, item.text && {
	              $$typeof: _typeofReactElement,
	              type: 'div',
	              key: null,
	              ref: null,
	              props: {
	                children: {
	                  $$typeof: _typeofReactElement,
	                  type: 'div',
	                  key: null,
	                  ref: null,
	                  props: {
	                    dangerouslySetInnerHTML: { __html: item.text }
	                  },
	                  _owner: null
	                },
	                className: 'Item__text'
	              },
	              _owner: null
	            }, item.type === 'poll' && {
	              $$typeof: _typeofReactElement,
	              type: 'div',
	              key: null,
	              ref: null,
	              props: {
	                children: item.parts.map(function (id) {
	                  return {
	                    $$typeof: _typeofReactElement,
	                    type: PollOption,
	                    key: id,
	                    ref: null,
	                    props: _defaultProps(PollOption.defaultProps, {
	                      id: id
	                    }),
	                    _owner: null
	                  };
	                }),
	                className: 'Item__poll'
	              },
	              _owner: null
	            }],
	            className: 'Item__content'
	          },
	          _owner: null
	        }, item.kids && {
	          $$typeof: _typeofReactElement,
	          type: 'div',
	          key: null,
	          ref: null,
	          props: {
	            children: item.kids.map(function (id, index) {
	              return {
	                $$typeof: _typeofReactElement,
	                type: Comment,
	                key: id,
	                ref: null,
	                props: _defaultProps(Comment.defaultProps, {
	                  id: id,
	                  level: 0,
	                  loadingSpinner: index === 0,
	                  threadStore: threadStore
	                }),
	                _owner: null
	              };
	            }),
	            className: 'Item__kids'
	          },
	          _owner: null
	        }],
	        className: cx('Item', { 'Item--dead': item.dead })
	      },
	      _owner: null
	    };
	  }
	});
	
	module.exports = Item;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	var React = __webpack_require__(2);
	
	var _ref = {
	  $$typeof: _typeofReactElement,
	  type: 'h2',
	  key: null,
	  ref: null,
	  props: {
	    children: 'Not found'
	  },
	  _owner: null
	};
	var NotFound = React.createClass({
	  displayName: 'NotFound',
	
	  render: function render() {
	    return _ref;
	  }
	});
	
	module.exports = NotFound;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	var React = __webpack_require__(2);
	var ReactFireMixin = __webpack_require__(31);
	
	var CommentThreadStore = __webpack_require__(57);
	var HNService = __webpack_require__(14);
	var SettingsStore = __webpack_require__(8);
	var UpdatesStore = __webpack_require__(40);
	
	var Comment = __webpack_require__(87);
	var CommentMixin = __webpack_require__(55);
	
	var cx = __webpack_require__(32);
	var _setTitle = __webpack_require__(35);
	
	var PermalinkedComment = React.createClass({
	  displayName: 'PermalinkedComment',
	
	  mixins: [CommentMixin, ReactFireMixin],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      level: 0,
	      loadingSpinner: true
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      comment: UpdatesStore.getComment(this.props.params.id) || {},
	      parent: { type: 'comment' },
	      op: {}
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.bindAsObject(HNService.itemRef(this.props.params.id), 'comment');
	    if (this.state.comment.id) {
	      this.commentLoaded(this.state.comment);
	    }
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.params.id !== this.props.params.id) {
	      var comment = UpdatesStore.getComment(nextProps.params.id);
	      if (comment) {
	        this.commentLoaded(comment);
	        this.setState({ comment: comment });
	      }
	      this.unbind('comment');
	      this.bindAsObject(HNService.itemRef(nextProps.params.id), 'comment');
	    }
	  },
	
	  componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
	    if (!nextState.comment) {
	      return;
	    }
	
	    if (this.state.comment.id !== nextState.comment.id) {
	      if (!nextState.comment.deleted) {
	        // Redirect to the appropriate route if a Comment "parent" link had a
	        // non-comment item id.
	        if (nextState.comment.type !== 'comment') {
	          this.context.router.replaceWith(nextState.comment.type, { id: nextState.comment.id });
	          return;
	        }
	      }
	      if (!this.threadStore || this.threadStore.itemId !== nextState.comment.id) {
	        this.commentLoaded(nextState.comment);
	      }
	    }
	  },
	
	  commentLoaded: function commentLoaded(comment) {
	    this.setTitle(comment);
	    if (!comment.deleted) {
	      this.threadStore = new CommentThreadStore(comment, this.handleCommentsChanged);
	      this.fetchAncestors(comment);
	    }
	  },
	
	  setTitle: function setTitle(comment) {
	    if (comment.deleted) {
	      return _setTitle('Deleted comment');
	    }
	    var title = 'Comment by ' + comment.by;
	    if (this.state.op.id) {
	      title += ' | ' + this.state.op.title;
	    }
	    _setTitle(title);
	  },
	
	  handleCommentsChanged: function handleCommentsChanged(payload) {
	    // We're only interested in re-rendering to update collapsed display
	    if (payload.type === 'collapse') {
	      this.forceUpdate();
	    }
	  },
	
	  render: function render() {
	    var comment = this.state.comment;
	    if (!comment) {
	      return this.renderError(comment, {
	        id: this.props.params.id,
	        className: 'Comment Comment--level0 Comment--error'
	      });
	    }
	    // Render a placeholder while we're waiting for the comment to load
	    if (!comment.id) {
	      return this.renderCommentLoading(comment);
	    }
	    // Render a link to HN for deleted comments
	    if (comment.deleted) {
	      return this.renderCommentDeleted(comment, {
	        className: 'Comment Comment--level0 Comment--deleted'
	      });
	    }
	    // XXX Don't render anything if we're replacing the route after loading a non-comment
	    if (comment.type !== 'comment') {
	      return null;
	    }
	
	    var className = cx('PermalinkedComment Comment Comment--level0', { 'Comment--dead': comment.dead });
	    var threadStore = this.threadStore;
	
	    return {
	      $$typeof: _typeofReactElement,
	      type: 'div',
	      key: null,
	      ref: null,
	      props: {
	        children: [{
	          $$typeof: _typeofReactElement,
	          type: 'div',
	          key: null,
	          ref: null,
	          props: {
	            children: [this.renderCommentMeta(comment, {
	              parent: !!this.state.parent.id && !!this.state.op.id && comment.parent !== this.state.op.id,
	              op: !!this.state.op.id
	            }), (!comment.dead || SettingsStore.showDead) && this.renderCommentText(comment, { replyLink: true })],
	            className: 'Comment__content'
	          },
	          _owner: null
	        }, comment.kids && {
	          $$typeof: _typeofReactElement,
	          type: 'div',
	          key: null,
	          ref: null,
	          props: {
	            children: comment.kids.map(function (id, index) {
	              return {
	                $$typeof: _typeofReactElement,
	                type: Comment,
	                key: id,
	                ref: null,
	                props: _defaultProps(Comment.defaultProps, {
	                  id: id,
	                  level: 0,
	                  loadingSpinner: index === 0,
	                  threadStore: threadStore
	                }),
	                _owner: null
	              };
	            }),
	            className: 'Comment__kids'
	          },
	          _owner: null
	        }],
	        className: className
	      },
	      _owner: null
	    };
	  }
	});
	
	module.exports = PermalinkedComment;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	var React = __webpack_require__(2);
	var ReactFireMixin = __webpack_require__(31);
	
	var HNService = __webpack_require__(14);
	
	var Spinner = __webpack_require__(21);
	
	var pluralise = __webpack_require__(34);
	
	var _ref = {
	  $$typeof: _typeofReactElement,
	  type: 'div',
	  key: null,
	  ref: null,
	  props: {
	    children: {
	      $$typeof: _typeofReactElement,
	      type: Spinner,
	      key: null,
	      ref: null,
	      props: _defaultProps(Spinner.defaultProps, {
	        size: '20'
	      }),
	      _owner: null
	    },
	    className: 'PollOption PollOption--loading'
	  },
	  _owner: null
	};
	var PollOption = React.createClass({
	  displayName: 'PollOption',
	
	  mixins: [ReactFireMixin],
	
	  getInitialState: function getInitialState() {
	    return { pollopt: {} };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.bindAsObject(HNService.itemRef(this.props.id), 'pollopt');
	  },
	
	  render: function render() {
	    var pollopt = this.state.pollopt;
	    if (!pollopt.id) {
	      return _ref;
	    }
	    return {
	      $$typeof: _typeofReactElement,
	      type: 'div',
	      key: null,
	      ref: null,
	      props: {
	        children: [{
	          $$typeof: _typeofReactElement,
	          type: 'div',
	          key: null,
	          ref: null,
	          props: {
	            children: pollopt.text,
	            className: 'PollOption__text'
	          },
	          _owner: null
	        }, {
	          $$typeof: _typeofReactElement,
	          type: 'div',
	          key: null,
	          ref: null,
	          props: {
	            children: [pollopt.score, ' point', pluralise(pollopt.score)],
	            className: 'PollOption__score'
	          },
	          _owner: null
	        }],
	        className: 'PollOption'
	      },
	      _owner: null
	    };
	  }
	});
	
	module.exports = PollOption;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	var React = __webpack_require__(2);
	
	var SettingsStore = __webpack_require__(8);
	
	var _ref = {
	  $$typeof: _typeofReactElement,
	  type: 'p',
	  key: null,
	  ref: null,
	  props: {
	    children: 'Automatically collapse comment threads without new comments on page load.'
	  },
	  _owner: null
	};
	var _ref2 = {
	  $$typeof: _typeofReactElement,
	  type: 'p',
	  key: null,
	  ref: null,
	  props: {
	    children: 'Show "reply" links to Hacker News'
	  },
	  _owner: null
	};
	var _ref3 = {
	  $$typeof: _typeofReactElement,
	  type: 'p',
	  key: null,
	  ref: null,
	  props: {
	    children: 'Show items flagged as dead.'
	  },
	  _owner: null
	};
	var _ref4 = {
	  $$typeof: _typeofReactElement,
	  type: 'p',
	  key: null,
	  ref: null,
	  props: {
	    children: 'Show comments flagged as deleted in threads.'
	  },
	  _owner: null
	};
	var _ref5 = {
	  $$typeof: _typeofReactElement,
	  type: 'p',
	  key: null,
	  ref: null,
	  props: {
	    children: 'Dark theme mode'
	  },
	  _owner: null
	};
	var _ref6 = {
	  $$typeof: _typeofReactElement,
	  type: 'td',
	  key: null,
	  ref: null,
	  props: {
	    children: {
	      $$typeof: _typeofReactElement,
	      type: 'label',
	      key: null,
	      ref: null,
	      props: {
	        children: 'title font size:',
	        htmlFor: 'titleFontSize'
	      },
	      _owner: null
	    }
	  },
	  _owner: null
	};
	var _ref7 = {
	  $$typeof: _typeofReactElement,
	  type: 'td',
	  key: null,
	  ref: null,
	  props: {
	    children: {
	      $$typeof: _typeofReactElement,
	      type: 'label',
	      key: null,
	      ref: null,
	      props: {
	        children: 'list spacing:',
	        htmlFor: 'listSpacing'
	      },
	      _owner: null
	    }
	  },
	  _owner: null
	};
	var Settings = React.createClass({
	  displayName: 'Settings',
	
	  componentDidMount: function componentDidMount() {
	    this.refs.container.focus();
	  },
	
	  onChange: function onChange(e) {
	    var el = e.target;
	    if (el.type === 'checkbox') {
	      SettingsStore[el.name] = el.checked;
	    } else if (el.type === 'radio') {
	      SettingsStore[el.name] = el.value;
	    } else if (el.type === 'number' && el.value) {
	      SettingsStore[el.name] = el.value;
	    }
	    this.forceUpdate();
	    SettingsStore.save();
	  },
	
	  onClick: function onClick(e) {
	    e.stopPropagation();
	  },
	
	  checkStore: function checkStore(datastoreKey, value) {
	    return SettingsStore[datastoreKey] === value;
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var RadioInput = function RadioInput(_ref8) {
	      var value = _ref8.value;
	      var label = _ref8.label;
	      var datastoreKey = _ref8.datastoreKey;
	      return {
	        $$typeof: _typeofReactElement,
	        type: 'p',
	        key: null,
	        ref: null,
	        props: {
	          children: [{
	            $$typeof: _typeofReactElement,
	            type: 'input',
	            key: null,
	            ref: null,
	            props: {
	              type: 'radio',
	              name: datastoreKey,
	              value: value,
	              id: datastoreKey + '-' + label,
	              checked: _this.checkStore(datastoreKey, value)
	            },
	            _owner: null
	          }, ' ', {
	            $$typeof: _typeofReactElement,
	            type: 'label',
	            key: null,
	            ref: null,
	            props: {
	              children: label,
	              htmlFor: datastoreKey + '-' + label
	            },
	            _owner: null
	          }]
	        },
	        _owner: null
	      };
	    };
	
	    return React.createElement(
	      'div',
	      { ref: 'container', className: 'Settings', tabIndex: '-1', onClick: this.onClick },
	      {
	        $$typeof: _typeofReactElement,
	        type: 'form',
	        key: null,
	        ref: null,
	        props: {
	          children: [{
	            $$typeof: _typeofReactElement,
	            type: 'div',
	            key: null,
	            ref: null,
	            props: {
	              children: [{
	                $$typeof: _typeofReactElement,
	                type: 'label',
	                key: null,
	                ref: null,
	                props: {
	                  children: [{
	                    $$typeof: _typeofReactElement,
	                    type: 'input',
	                    key: null,
	                    ref: null,
	                    props: {
	                      type: 'checkbox',
	                      name: 'autoCollapse',
	                      id: 'autoCollapse',
	                      checked: SettingsStore.autoCollapse
	                    },
	                    _owner: null
	                  }, ' auto collapse'],
	                  htmlFor: 'autoCollapse'
	                },
	                _owner: null
	              }, _ref],
	              className: 'Settings__setting Settings__setting--checkbox'
	            },
	            _owner: null
	          }, {
	            $$typeof: _typeofReactElement,
	            type: 'div',
	            key: null,
	            ref: null,
	            props: {
	              children: [{
	                $$typeof: _typeofReactElement,
	                type: 'label',
	                key: null,
	                ref: null,
	                props: {
	                  children: [{
	                    $$typeof: _typeofReactElement,
	                    type: 'input',
	                    key: null,
	                    ref: null,
	                    props: {
	                      type: 'checkbox',
	                      name: 'replyLinks',
	                      id: 'replyLinks',
	                      checked: SettingsStore.replyLinks
	                    },
	                    _owner: null
	                  }, ' show reply links'],
	                  htmlFor: 'replyLinks'
	                },
	                _owner: null
	              }, _ref2],
	              className: 'Settings__setting Settings__setting--checkbox'
	            },
	            _owner: null
	          }, {
	            $$typeof: _typeofReactElement,
	            type: 'div',
	            key: null,
	            ref: null,
	            props: {
	              children: [{
	                $$typeof: _typeofReactElement,
	                type: 'label',
	                key: null,
	                ref: null,
	                props: {
	                  children: [{
	                    $$typeof: _typeofReactElement,
	                    type: 'input',
	                    key: null,
	                    ref: null,
	                    props: {
	                      type: 'checkbox',
	                      name: 'showDead',
	                      id: 'showDead',
	                      checked: SettingsStore.showDead
	                    },
	                    _owner: null
	                  }, ' show dead'],
	                  htmlFor: 'showDead'
	                },
	                _owner: null
	              }, _ref3],
	              className: 'Settings__setting Settings__setting--checkbox'
	            },
	            _owner: null
	          }, {
	            $$typeof: _typeofReactElement,
	            type: 'div',
	            key: null,
	            ref: null,
	            props: {
	              children: [{
	                $$typeof: _typeofReactElement,
	                type: 'label',
	                key: null,
	                ref: null,
	                props: {
	                  children: [{
	                    $$typeof: _typeofReactElement,
	                    type: 'input',
	                    key: null,
	                    ref: null,
	                    props: {
	                      type: 'checkbox',
	                      name: 'showDeleted',
	                      id: 'showDeleted',
	                      checked: SettingsStore.showDeleted
	                    },
	                    _owner: null
	                  }, ' show deleted'],
	                  htmlFor: 'showDeleted'
	                },
	                _owner: null
	              }, _ref4],
	              className: 'Settings__setting Settings__setting--checkbox'
	            },
	            _owner: null
	          }, {
	            $$typeof: _typeofReactElement,
	            type: 'div',
	            key: null,
	            ref: null,
	            props: {
	              children: [{
	                $$typeof: _typeofReactElement,
	                type: RadioInput,
	                key: null,
	                ref: null,
	                props: _defaultProps(RadioInput.defaultProps, {
	                  value: 'auto',
	                  label: 'auto',
	                  datastoreKey: 'darkThemeMode'
	                }),
	                _owner: null
	              }, {
	                $$typeof: _typeofReactElement,
	                type: RadioInput,
	                key: null,
	                ref: null,
	                props: _defaultProps(RadioInput.defaultProps, {
	                  value: 'light',
	                  label: 'light',
	                  datastoreKey: 'darkThemeMode'
	                }),
	                _owner: null
	              }, {
	                $$typeof: _typeofReactElement,
	                type: RadioInput,
	                key: null,
	                ref: null,
	                props: _defaultProps(RadioInput.defaultProps, {
	                  value: 'dark',
	                  label: 'dark',
	                  datastoreKey: 'darkThemeMode'
	                }),
	                _owner: null
	              }, _ref5],
	              className: 'Settings__setting Settings__setting--checkbox'
	            },
	            _owner: null
	          }, {
	            $$typeof: _typeofReactElement,
	            type: 'div',
	            key: null,
	            ref: null,
	            props: {
	              children: {
	                $$typeof: _typeofReactElement,
	                type: 'table',
	                key: null,
	                ref: null,
	                props: {
	                  children: {
	                    $$typeof: _typeofReactElement,
	                    type: 'tbody',
	                    key: null,
	                    ref: null,
	                    props: {
	                      children: [{
	                        $$typeof: _typeofReactElement,
	                        type: 'tr',
	                        key: null,
	                        ref: null,
	                        props: {
	                          children: [_ref6, {
	                            $$typeof: _typeofReactElement,
	                            type: 'td',
	                            key: null,
	                            ref: null,
	                            props: {
	                              children: {
	                                $$typeof: _typeofReactElement,
	                                type: 'input',
	                                key: null,
	                                ref: null,
	                                props: {
	                                  type: 'number',
	                                  min: '13.333',
	                                  step: '1',
	                                  name: 'titleFontSize',
	                                  id: 'titleFontSize',
	                                  value: SettingsStore.titleFontSize
	                                },
	                                _owner: null
	                              }
	                            },
	                            _owner: null
	                          }]
	                        },
	                        _owner: null
	                      }, {
	                        $$typeof: _typeofReactElement,
	                        type: 'tr',
	                        key: null,
	                        ref: null,
	                        props: {
	                          children: [_ref7, {
	                            $$typeof: _typeofReactElement,
	                            type: 'td',
	                            key: null,
	                            ref: null,
	                            props: {
	                              children: {
	                                $$typeof: _typeofReactElement,
	                                type: 'input',
	                                key: null,
	                                ref: null,
	                                props: {
	                                  type: 'number',
	                                  min: '0',
	                                  name: 'listSpacing',
	                                  id: 'listSpacing',
	                                  value: SettingsStore.listSpacing
	                                },
	                                _owner: null
	                              }
	                            },
	                            _owner: null
	                          }]
	                        },
	                        _owner: null
	                      }]
	                    },
	                    _owner: null
	                  }
	                },
	                _owner: null
	              },
	              className: 'Settings__setting'
	            },
	            _owner: null
	          }],
	          onChange: this.onChange
	        },
	        _owner: null
	      }
	    );
	  }
	});
	
	module.exports = Settings;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	var React = __webpack_require__(2);
	
	var StoryStore = __webpack_require__(39);
	
	var PageNumberMixin = __webpack_require__(90);
	var Paginator = __webpack_require__(88);
	var Spinner = __webpack_require__(21);
	var StoryListItem = __webpack_require__(150);
	var SettingsStore = __webpack_require__(8);
	
	var _require = __webpack_require__(41);
	
	var ITEMS_PER_PAGE = _require.ITEMS_PER_PAGE;
	
	var pageCalc = __webpack_require__(92);
	var setTitle = __webpack_require__(35);
	
	var _ref = {
	  $$typeof: _typeofReactElement,
	  type: Spinner,
	  key: null,
	  ref: null,
	  props: _defaultProps(Spinner.defaultProps, {}),
	  _owner: null
	};
	var Stories = React.createClass({
	  displayName: 'Stories',
	
	  mixins: [PageNumberMixin],
	
	  propTypes: {
	    // The number of stories which may be paginated through
	    limit: React.PropTypes.number.isRequired,
	    // The route name being used
	    route: React.PropTypes.string.isRequired,
	    // The type of stories to be displayed
	    type: React.PropTypes.string.isRequired,
	
	    // Page title associated with the stories being displayed
	    title: React.PropTypes.string
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      ids: [],
	      limit: this.props.limit,
	      stories: []
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    setTitle(this.props.title);
	    this.store = new StoryStore(this.props.type);
	    this.store.addListener('update', this.handleUpdate);
	    this.store.start();
	    this.setState(this.store.getState());
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.store.removeListener('update', this.handleUpdate);
	    this.store.stop();
	    this.store = null;
	  },
	
	  handleUpdate: function handleUpdate(update) {
	    if (!this.isMounted()) {
	      if (false) {
	        console.warn('Skipping update as the ' + this.props.type + ' Stories component is no longer mounted.');
	      }
	      return;
	    }
	    update.limit = update.ids.length;
	    this.setState(update);
	  },
	
	  render: function render() {
	    var page = pageCalc(this.getPageNumber(), ITEMS_PER_PAGE, this.state.limit);
	
	    // Display a list of placeholder items while we're waiting for the initial
	    // list of story ids to load from Firebase.
	    if (this.state.stories.length === 0 && this.state.ids.length === 0) {
	      var dummyItems = [];
	      for (var i = page.startIndex; i < page.endIndex; i++) {
	        dummyItems.push({
	          $$typeof: _typeofReactElement,
	          type: 'li',
	          key: i,
	          ref: null,
	          props: {
	            children: _ref,
	            className: 'ListItem ListItem--loading',
	            style: { marginBottom: SettingsStore.listSpacing }
	          },
	          _owner: null
	        });
	      }
	      return {
	        $$typeof: _typeofReactElement,
	        type: 'div',
	        key: null,
	        ref: null,
	        props: {
	          children: [{
	            $$typeof: _typeofReactElement,
	            type: 'ol',
	            key: null,
	            ref: null,
	            props: {
	              children: dummyItems,
	              className: 'Items__list',
	              start: page.startIndex + 1
	            },
	            _owner: null
	          }, {
	            $$typeof: _typeofReactElement,
	            type: Paginator,
	            key: null,
	            ref: null,
	            props: _defaultProps(Paginator.defaultProps, {
	              route: this.props.route,
	              page: page.pageNum,
	              hasNext: page.hasNext
	            }),
	            _owner: null
	          }],
	          className: 'Items Items--loading'
	        },
	        _owner: null
	      };
	    }
	
	    return {
	      $$typeof: _typeofReactElement,
	      type: 'div',
	      key: null,
	      ref: null,
	      props: {
	        children: [{
	          $$typeof: _typeofReactElement,
	          type: 'ol',
	          key: null,
	          ref: null,
	          props: {
	            children: this.renderItems(page.startIndex, page.endIndex),
	            className: 'Items__list',
	            start: page.startIndex + 1
	          },
	          _owner: null
	        }, {
	          $$typeof: _typeofReactElement,
	          type: Paginator,
	          key: null,
	          ref: null,
	          props: _defaultProps(Paginator.defaultProps, {
	            route: this.props.route,
	            page: page.pageNum,
	            hasNext: page.hasNext
	          }),
	          _owner: null
	        }],
	        className: 'Items'
	      },
	      _owner: null
	    };
	  },
	
	  renderItems: function renderItems(startIndex, endIndex) {
	    var rendered = [];
	    for (var i = startIndex; i < endIndex; i++) {
	      var item = this.state.stories[i];
	      var id = this.state.ids[i];
	      if (id) {
	        rendered.push({
	          $$typeof: _typeofReactElement,
	          type: StoryListItem,
	          key: id,
	          ref: null,
	          props: _defaultProps(StoryListItem.defaultProps, {
	            id: id,
	            index: i,
	            cachedItem: item,
	            store: this.store
	          }),
	          _owner: null
	        });
	      } else {
	        rendered.push({
	          $$typeof: _typeofReactElement,
	          type: StoryListItem,
	          key: null,
	          ref: null,
	          props: _defaultProps(StoryListItem.defaultProps, {
	            cachedItem: item,
	            store: this.store
	          }),
	          _owner: null
	        });
	      }
	    }
	    return rendered;
	  }
	});
	
	module.exports = Stories;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	var React = __webpack_require__(2);
	var ReactFireMixin = __webpack_require__(31);
	
	var StoryCommentThreadStore = __webpack_require__(58);
	var HNService = __webpack_require__(14);
	var SettingsStore = __webpack_require__(8);
	var StoryStore = __webpack_require__(39);
	
	var ItemMixin = __webpack_require__(56);
	var ListItemMixin = __webpack_require__(89);
	var Spinner = __webpack_require__(21);
	
	/**
	 * Display story title and metadata as as a list item.
	 * Cached story data may be given as a prop, but this component is also
	 * responsible for listening to updates to the story and providing the latest
	 * version for StoryStore's cache.
	 */
	var _ref = {
	  $$typeof: _typeofReactElement,
	  type: Spinner,
	  key: null,
	  ref: null,
	  props: _defaultProps(Spinner.defaultProps, {}),
	  _owner: null
	};
	var StoryListItem = React.createClass({
	  displayName: 'StoryListItem',
	
	  mixins: [ItemMixin, ListItemMixin, ReactFireMixin],
	
	  propTypes: {
	    // The StoryStore handling caching and updates to the stories being displayed
	    store: React.PropTypes.instanceOf(StoryStore).isRequired,
	
	    // The story's id in Hacker News
	    id: React.PropTypes.number,
	    // A version of the story from the cache, for initial display
	    cachedItem: React.PropTypes.object,
	    // The current index of the story in the list being displayed
	    index: React.PropTypes.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      id: null,
	      cachedItem: null,
	      index: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      item: this.props.cachedItem || {}
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    if (this.props.id != null) {
	      this.initLiveItem(this.props);
	    } else if (this.props.cachedItem != null) {
	      // Display the comment state of the cached item we were given while we're
	      // waiting for the live item to load.
	      this.threadState = StoryCommentThreadStore.loadState(this.state.item.id);
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.props.id != null) {
	      this.props.store.removeListener(this.props.id, this.updateThreadState);
	    }
	  },
	
	  /**
	   * Catch the transition from not having an id prop to having one.
	   * Scenario: we were waiting for the initial list of story ids to load.
	   */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.id == null && nextProps.id != null) {
	      this.initLiveItem(nextProps);
	    }
	  },
	
	  /**
	   * If the live item has been loaded or updated, update the StoryStore cache
	   * with its current index and latest data.
	   */
	  componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
	    if (this.state.item !== nextState.item) {
	      if (nextState.item != null) {
	        this.props.store.itemUpdated(nextState.item, this.props.index);
	      } else {
	        if (false) {
	          console.warn('Item ' + this.props.id + ' went from ' + JSON.stringify(this.state.item) + ' to ' + nextProps.item);
	        }
	      }
	    }
	  },
	
	  /**
	   * Initialise listening to updates for the item with the given id and
	   * initialise its comment thread state.
	   */
	  initLiveItem: function initLiveItem(props) {
	    // If we were given a cached item to display initially, it will be replaced
	    this.bindAsObject(HNService.itemRef(props.id), 'item');
	    this.threadState = StoryCommentThreadStore.loadState(props.id);
	    this.props.store.addListener(props.id, this.updateThreadState);
	  },
	
	  /**
	   * Update thread state in response to a storage event indicating it has been
	   * modified.
	   */
	  updateThreadState: function updateThreadState() {
	    this.threadState = StoryCommentThreadStore.loadState(this.props.id);
	    this.forceUpdate();
	  },
	
	  render: function render() {
	    // Display the loading spinner if we have nothing to show initially
	    if (!this.state.item || !this.state.item.id) {
	      return {
	        $$typeof: _typeofReactElement,
	        type: 'li',
	        key: null,
	        ref: null,
	        props: {
	          children: _ref,
	          className: 'ListItem ListItem--loading',
	          style: { marginBottom: SettingsStore.listSpacing }
	        },
	        _owner: null
	      };
	    }
	
	    return this.renderListItem(this.state.item, this.threadState);
	  }
	});
	
	module.exports = StoryListItem;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	var React = __webpack_require__(2);
	
	var SettingsStore = __webpack_require__(8);
	var UpdatesStore = __webpack_require__(40);
	
	var DisplayListItem = __webpack_require__(143);
	var DisplayComment = __webpack_require__(142);
	var Paginator = __webpack_require__(88);
	var Spinner = __webpack_require__(21);
	
	var PageNumberMixin = __webpack_require__(90);
	
	var _require = __webpack_require__(41);
	
	var ITEMS_PER_PAGE = _require.ITEMS_PER_PAGE;
	
	var pageCalc = __webpack_require__(92);
	var _setTitle = __webpack_require__(35);
	
	function filterDead(item) {
	  return !item.dead;
	}
	
	function filterUpdates(updates) {
	  if (!SettingsStore.showDead) {
	    return {
	      comments: updates.comments.filter(filterDead),
	      stories: updates.stories.filter(filterDead)
	    };
	  }
	  return updates;
	}
	
	var _ref = {
	  $$typeof: _typeofReactElement,
	  type: 'div',
	  key: null,
	  ref: null,
	  props: {
	    children: {
	      $$typeof: _typeofReactElement,
	      type: Spinner,
	      key: null,
	      ref: null,
	      props: _defaultProps(Spinner.defaultProps, {
	        size: '20'
	      }),
	      _owner: null
	    },
	    className: 'Updates Updates--loading'
	  },
	  _owner: null
	};
	var Updates = React.createClass({
	  displayName: 'Updates',
	
	  mixins: [PageNumberMixin],
	
	  getInitialState: function getInitialState() {
	    return filterUpdates(UpdatesStore.getUpdates());
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.setTitle(this.props.type);
	    UpdatesStore.start();
	    UpdatesStore.on('updates', this.handleUpdates);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    UpdatesStore.off('updates', this.handleUpdates);
	    UpdatesStore.stop();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.type !== nextProps.type) {
	      this.setTitle(nextProps.type);
	    }
	  },
	
	  setTitle: function setTitle(type) {
	    _setTitle('New ' + (type === 'comments' ? 'Comments' : 'Links'));
	  },
	
	  handleUpdates: function handleUpdates(updates) {
	    if (!this.isMounted()) {
	      if (false) {
	        console.warn('Skipping update of ' + this.props.type + ' as the Updates component is not mounted');
	      }
	      return;
	    }
	    this.setState(filterUpdates(updates));
	  },
	
	  render: function render() {
	    var items = this.props.type === 'comments' ? this.state.comments : this.state.stories;
	    if (items.length === 0) {
	      return _ref;
	    }
	
	    var page = pageCalc(this.getPageNumber(), ITEMS_PER_PAGE, items.length);
	
	    if (this.props.type === 'comments') {
	      return {
	        $$typeof: _typeofReactElement,
	        type: 'div',
	        key: null,
	        ref: null,
	        props: {
	          children: [items.slice(page.startIndex, page.endIndex).map(function (comment) {
	            return {
	              $$typeof: _typeofReactElement,
	              type: DisplayComment,
	              key: comment.id,
	              ref: null,
	              props: _defaultProps(DisplayComment.defaultProps, {
	                id: comment.id,
	                comment: comment
	              }),
	              _owner: null
	            };
	          }), {
	            $$typeof: _typeofReactElement,
	            type: Paginator,
	            key: null,
	            ref: null,
	            props: _defaultProps(Paginator.defaultProps, {
	              route: 'newcomments',
	              page: page.pageNum,
	              hasNext: page.hasNext
	            }),
	            _owner: null
	          }],
	          className: 'Updates Comments'
	        },
	        _owner: null
	      };
	    } else {
	      return {
	        $$typeof: _typeofReactElement,
	        type: 'div',
	        key: null,
	        ref: null,
	        props: {
	          children: [{
	            $$typeof: _typeofReactElement,
	            type: 'ol',
	            key: null,
	            ref: null,
	            props: {
	              children: items.slice(page.startIndex, page.endIndex).map(function (item) {
	                return {
	                  $$typeof: _typeofReactElement,
	                  type: DisplayListItem,
	                  key: item.id,
	                  ref: null,
	                  props: _defaultProps(DisplayListItem.defaultProps, {
	                    item: item
	                  }),
	                  _owner: null
	                };
	              }),
	              className: 'Items__list',
	              start: page.startIndex + 1
	            },
	            _owner: null
	          }, {
	            $$typeof: _typeofReactElement,
	            type: Paginator,
	            key: null,
	            ref: null,
	            props: _defaultProps(Paginator.defaultProps, {
	              route: 'newest',
	              page: page.pageNum,
	              hasNext: page.hasNext
	            }),
	            _owner: null
	          }],
	          className: 'Updates Items'
	        },
	        _owner: null
	      };
	    }
	  }
	});
	
	module.exports = Updates;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	var React = __webpack_require__(2);
	var ReactFireMixin = __webpack_require__(31);
	var TimeAgo = __webpack_require__(46)['default'];
	
	var HNService = __webpack_require__(14);
	
	var Spinner = __webpack_require__(21);
	
	var setTitle = __webpack_require__(35);
	
	// TODO User submissions
	
	// TODO User comments
	
	var _ref = {
	  $$typeof: _typeofReactElement,
	  type: Spinner,
	  key: null,
	  ref: null,
	  props: _defaultProps(Spinner.defaultProps, {
	    size: '20'
	  }),
	  _owner: null
	};
	var _ref2 = {
	  $$typeof: _typeofReactElement,
	  type: 'dt',
	  key: null,
	  ref: null,
	  props: {
	    children: 'Created'
	  },
	  _owner: null
	};
	var _ref3 = {
	  $$typeof: _typeofReactElement,
	  type: 'dt',
	  key: null,
	  ref: null,
	  props: {
	    children: 'Karma'
	  },
	  _owner: null
	};
	var _ref4 = {
	  $$typeof: _typeofReactElement,
	  type: 'dt',
	  key: null,
	  ref: null,
	  props: {
	    children: 'Delay'
	  },
	  _owner: null
	};
	var _ref5 = {
	  $$typeof: _typeofReactElement,
	  type: 'dt',
	  key: null,
	  ref: null,
	  props: {
	    children: 'About'
	  },
	  _owner: null
	};
	var UserProfile = React.createClass({
	  displayName: 'UserProfile',
	
	  mixins: [ReactFireMixin],
	  getInitialState: function getInitialState() {
	    return { user: {} };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.bindAsObject(HNService.userRef(this.props.params.id), 'user');
	  },
	
	  componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
	    if (this.state.user.id !== nextState.user.id) {
	      setTitle('Profile: ' + nextState.user.id);
	    }
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.params.id !== nextProps.params.id) {
	      this.unbind('user');
	      this.bindAsObject(HNService.userRef(nextProps.params.id), 'user');
	    }
	  },
	
	  render: function render() {
	    var user = this.state.user;
	    if (!user.id) {
	      return {
	        $$typeof: _typeofReactElement,
	        type: 'div',
	        key: null,
	        ref: null,
	        props: {
	          children: [{
	            $$typeof: _typeofReactElement,
	            type: 'h4',
	            key: null,
	            ref: null,
	            props: {
	              children: this.props.params.id
	            },
	            _owner: null
	          }, _ref],
	          className: 'UserProfile UserProfile--loading'
	        },
	        _owner: null
	      };
	    }
	    var createdDate = new Date(user.created * 1000);
	    return {
	      $$typeof: _typeofReactElement,
	      type: 'div',
	      key: null,
	      ref: null,
	      props: {
	        children: [{
	          $$typeof: _typeofReactElement,
	          type: 'h4',
	          key: null,
	          ref: null,
	          props: {
	            children: user.id
	          },
	          _owner: null
	        }, {
	          $$typeof: _typeofReactElement,
	          type: 'dl',
	          key: null,
	          ref: null,
	          props: {
	            children: [_ref2, {
	              $$typeof: _typeofReactElement,
	              type: 'dd',
	              key: null,
	              ref: null,
	              props: {
	                children: [{
	                  $$typeof: _typeofReactElement,
	                  type: TimeAgo,
	                  key: null,
	                  ref: null,
	                  props: _defaultProps(TimeAgo.defaultProps, {
	                    date: createdDate
	                  }),
	                  _owner: null
	                }, ' (', createdDate.toDateString(), ')']
	              },
	              _owner: null
	            }, _ref3, {
	              $$typeof: _typeofReactElement,
	              type: 'dd',
	              key: null,
	              ref: null,
	              props: {
	                children: user.karma
	              },
	              _owner: null
	            }, _ref4, {
	              $$typeof: _typeofReactElement,
	              type: 'dd',
	              key: null,
	              ref: null,
	              props: {
	                children: user.delay
	              },
	              _owner: null
	            }, user.about && _ref5, user.about && {
	              $$typeof: _typeofReactElement,
	              type: 'dd',
	              key: null,
	              ref: null,
	              props: {
	                children: {
	                  $$typeof: _typeofReactElement,
	                  type: 'div',
	                  key: null,
	                  ref: null,
	                  props: {
	                    className: 'UserProfile__about',
	                    dangerouslySetInnerHTML: { __html: user.about }
	                  },
	                  _owner: null
	                }
	              },
	              _owner: null
	            }]
	          },
	          _owner: null
	        }],
	        className: 'UserProfile'
	      },
	      _owner: null
	    };
	  }
	});
	
	module.exports = UserProfile;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	var IndexRoute = __webpack_require__(105);
	var React = __webpack_require__(2);
	var Route = __webpack_require__(107);
	
	var App = __webpack_require__(141);
	var Item = __webpack_require__(144);
	var NotFound = __webpack_require__(145);
	var PermalinkedComment = __webpack_require__(146);
	var Stories = __webpack_require__(149);
	var Updates = __webpack_require__(151);
	var UserProfile = __webpack_require__(152);
	
	function stories(route, type, limit, title) {
	  return React.createClass({
	    render: function render() {
	      return React.createElement(Stories, _extends({}, this.props, { key: route, route: route, type: type, limit: limit, title: title }));
	    }
	  });
	}
	
	function updates(type) {
	  return React.createClass({
	    render: function render() {
	      return React.createElement(Updates, _extends({}, this.props, { key: type, type: type }));
	    }
	  });
	}
	
	var Ask = stories('ask', 'askstories', 200, 'Ask');
	var Comments = updates('comments');
	var Jobs = stories('jobs', 'jobstories', 200, 'Jobs');
	var New = stories('newest', 'newstories', 500, 'New Links');
	var Show = stories('show', 'showstories', 200, 'Show');
	var Top = stories('news', 'topstories', 500);
	
	module.exports = {
	  $$typeof: _typeofReactElement,
	  type: Route,
	  key: null,
	  ref: null,
	  props: _defaultProps(Route.defaultProps, {
	    children: [{
	      $$typeof: _typeofReactElement,
	      type: IndexRoute,
	      key: null,
	      ref: null,
	      props: _defaultProps(IndexRoute.defaultProps, {
	        component: Top
	      }),
	      _owner: null
	    }, {
	      $$typeof: _typeofReactElement,
	      type: Route,
	      key: null,
	      ref: null,
	      props: _defaultProps(Route.defaultProps, {
	        path: 'news',
	        component: Top
	      }),
	      _owner: null
	    }, {
	      $$typeof: _typeofReactElement,
	      type: Route,
	      key: null,
	      ref: null,
	      props: _defaultProps(Route.defaultProps, {
	        path: 'newest',
	        component: New
	      }),
	      _owner: null
	    }, {
	      $$typeof: _typeofReactElement,
	      type: Route,
	      key: null,
	      ref: null,
	      props: _defaultProps(Route.defaultProps, {
	        path: 'show',
	        component: Show
	      }),
	      _owner: null
	    }, {
	      $$typeof: _typeofReactElement,
	      type: Route,
	      key: null,
	      ref: null,
	      props: _defaultProps(Route.defaultProps, {
	        path: 'ask',
	        component: Ask
	      }),
	      _owner: null
	    }, {
	      $$typeof: _typeofReactElement,
	      type: Route,
	      key: null,
	      ref: null,
	      props: _defaultProps(Route.defaultProps, {
	        path: 'jobs',
	        component: Jobs
	      }),
	      _owner: null
	    }, {
	      $$typeof: _typeofReactElement,
	      type: Route,
	      key: null,
	      ref: null,
	      props: _defaultProps(Route.defaultProps, {
	        path: 'item/:id',
	        component: Item
	      }),
	      _owner: null
	    }, {
	      $$typeof: _typeofReactElement,
	      type: Route,
	      key: null,
	      ref: null,
	      props: _defaultProps(Route.defaultProps, {
	        path: 'job/:id',
	        component: Item
	      }),
	      _owner: null
	    }, {
	      $$typeof: _typeofReactElement,
	      type: Route,
	      key: null,
	      ref: null,
	      props: _defaultProps(Route.defaultProps, {
	        path: 'poll/:id',
	        component: Item
	      }),
	      _owner: null
	    }, {
	      $$typeof: _typeofReactElement,
	      type: Route,
	      key: null,
	      ref: null,
	      props: _defaultProps(Route.defaultProps, {
	        path: 'story/:id',
	        component: Item
	      }),
	      _owner: null
	    }, {
	      $$typeof: _typeofReactElement,
	      type: Route,
	      key: null,
	      ref: null,
	      props: _defaultProps(Route.defaultProps, {
	        path: 'comment/:id',
	        component: PermalinkedComment
	      }),
	      _owner: null
	    }, {
	      $$typeof: _typeofReactElement,
	      type: Route,
	      key: null,
	      ref: null,
	      props: _defaultProps(Route.defaultProps, {
	        path: 'newcomments',
	        component: Comments
	      }),
	      _owner: null
	    }, {
	      $$typeof: _typeofReactElement,
	      type: Route,
	      key: null,
	      ref: null,
	      props: _defaultProps(Route.defaultProps, {
	        path: 'user/:id',
	        component: UserProfile
	      }),
	      _owner: null
	    }, {
	      $$typeof: _typeofReactElement,
	      type: Route,
	      key: null,
	      ref: null,
	      props: _defaultProps(Route.defaultProps, {
	        path: '*',
	        component: NotFound
	      }),
	      _owner: null
	    }],
	    path: '/',
	    component: App
	  }),
	  _owner: null
	};

/***/ },
/* 154 */
/***/ function(module, exports) {

	/**
	 * Based on the implementation of _.debounce() from Underscore.js 1.7.0
	 * http://underscorejs.org
	 * (c) 2009-2014 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Distributed under the MIT license.
	 *
	 * Returns a function, that, as long as it continues to be invoked, will not
	 * be triggered. The function will be called after it stops being called for
	 * N milliseconds. If `immediate` is passed, trigger the function on the
	 * leading edge, instead of the trailing.
	 *
	 * The returned function has a .cancel() function which can be used to prevent
	 * the debounced functiom being called.
	 */
	"use strict";
	
	function cancellableDebounce(func, wait, immediate) {
	  var timeout, args, context, timestamp, result;
	
	  var later = function later() {
	    var last = Date.now() - timestamp;
	    if (last < wait && last > 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	      if (!immediate) {
	        result = func.apply(context, args);
	        if (!timeout) {
	          context = args = null;
	        }
	      }
	    }
	  };
	
	  var debounced = function debounced() {
	    context = this;
	    args = arguments;
	    timestamp = Date.now();
	    var callNow = immediate && !timeout;
	    if (!timeout) {
	      timeout = setTimeout(later, wait);
	    }
	    if (callNow) {
	      result = func.apply(context, args);
	      context = args = null;
	    }
	    return result;
	  };
	
	  debounced.cancel = function () {
	    if (timeout) {
	      clearTimeout(timeout);
	    }
	  };
	
	  return debounced;
	}
	
	module.exports = cancellableDebounce;

/***/ }
]);


/** WEBPACK FOOTER **
 ** app.js
 **/